import React, { useState, useEffect, useRef, useContext } from 'react';
import Breadcrumb from '../components/Breadcrumb';
import { IoNewspaperOutline, IoSearchSharp } from 'react-icons/io5';
import { BiSolidEditAlt } from 'react-icons/bi';
import { CiEdit } from 'react-icons/ci';
import { MdDeleteForever } from 'react-icons/md';
import DatePicker from 'react-multi-date-picker';
import persian from 'react-date-object/calendars/persian';
import persian_fa from 'react-date-object/locales/persian_fa';
import { addDays, format as jalaliFormat } from 'date-fns-jalali';
import { Link, useSearchParams } from 'react-router-dom';
import { GrFormNext, GrFormPrevious } from 'react-icons/gr';
import ReactPaginate from 'react-paginate';
import { CustomPaper } from './CustomPager';
import Select from 'react-select/async';
import axios from 'axios';
import { FaRegWindowClose } from 'react-icons/fa';

import { TextField, Autocomplete } from '@mui/material';
import MySelectComponent from './components/MySelectComponent ';
import { DataContext } from '../context/DataProvider';
import SignIn from './Authentication/SignIn';
import SearchableDropDownLaw from '../SearchableDropDown/SearchableDropDownLaw';
import SearchableDropDownReLaw from '../SearchableDropDown/SearchableDropDownReLaw';
import { BsChevronLeft, BsChevronRight } from 'react-icons/bs';
import LawType from '../SearchableDropDown/LawType';
import { useParams } from 'react-router-dom';
import EditReform from './ModalComponents/EditReform';
const NewInfo = () => {
  const [savePage, setSavePage] = useState(1);
  let { id } = useParams();
  // console.log(id);
  const {
    isTokenExpired,
    fetchRefreshToken,
    tokenLogin,
    caseData,
    setcaseData,
    fetchListReSection,
    loading,
    setLoading,
    listReSection,
    setListReSection,
    listSections,
    setListSections,
    fetchListSection,

    fetchLops,
    ReFormEditFun,
    openEdiModal,
    setOpenEditModal,
    OpenCreateModal,
    setOpenCreateModal,
    openDeleteModalReform,
    setOpenDeleteModalReform,
    deleteID,
    setDeleteID,
    setReformInfo,
    ReformInfo,
    Lops,
    TextOrderListSection, setTextOrderListSection
  }: any = useContext(DataContext);
  // console.log('caseDAta', caseData);
  const [searchParams, setsearchParams] = useSearchParams();
  const page: number | any = searchParams.get('page');
  const [isTitleFault, setIsTitleFault] = useState<number | null>(2);
  const [whole, setWhole] = useState('null');
  const [Search, setSearch] = useState(id !== undefined ? id : '');
  const [SearchPage, setSearchPage] = useState(1);
  const [statusSearch, setStatusSearch] = useState(0);
  const [pageNum, setPageNum] = useState(null);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [SearchStatus, setSearchStatus] = useState([]);
  const [clickBtn, setClickBtn] = useState(false);
  const [SearchResult, setSearchResult] = useState([]);
  const [SearchResultCount, setSearchResultCount] = useState(1);
  const [reLaw, setReLaw] = useState('');
  const [LawList, setLawList] = useState([]);
  const [reLawList, setReLawList] = useState([]);
  const [open, setOpen] = useState(false);
  const [listRelation, setListRelation] = useState([]);
  const [AllStatus, setAllStatus] = useState([]);
  const [objectEdit, setObjectEdit] = useState({});
  const [pageCount, setPageCount] = useState(1);
  // const [listSections, setListSections] = useState([]);
  // const [listReSection, setListReSection] = useState([]);
  // const [loading, setLoading] = useState(true);
  const [isReplatedChecked, setisReplatedChecked] = useState<boolean | null>(
    false,
  );

  const [selectedOptionReLaw, setSelectedOptionReLaw] = useState(null);
  const [selectedOptionLaw, setSelectedOptionLaw] = useState(null);
  const [confirm, setConfirm] = useState('null');
  const [Type, setType] = useState<number | null>(8);
  const [checked, setChecked] = useState(false);
  const [pageSize, setPageSize] = useState(30);
  
  const [createModal, setCreateModal] = useState(false);
  const [date, setDate] = useState(new Date());
  const [fromDate, setFromDate] = useState(null);
  const [ToDate, setToDate] = useState(null);
  const handleDate = (date: any) => {
    if (date !== null) {
      setDate(new Date(date));
      setcaseData((caseData) => ({
        ...caseData,
        ExpireDate: jalaliFormat(new Date(date), 'yyyy/MM/dd'),
      }));
    } else {
      setcaseData((caseData) => ({
        ...caseData,
        ExpireDate: '',
      }));
    }
  };

  const isReplatedCheckedfun = async (e) => {
    if (e.target.value === 'null') {
      setisReplatedChecked(null);
    } else {
      setisReplatedChecked(e.target.value);
    }
  };
  const fetchSearchStatus = async () => {
    await fetch(`${process.env.REACT_APP_BASE_URL}/api/Data/Status?all=false`, {
      // headers: {
      //   Authorization: `Bearer ${tokenLogin.data?.accessToken}`,
      // },
    })
      .then((res) => res.json())
      .then((data) => setSearchStatus(data))
      .finally(() => setLoading(false));
  };
  // console.log(date);
  function deHilight(str) {
    return str
      .replaceAll(/\n/g, ' ')
      .replaceAll('</e>', ' ')
      .replaceAll('</b>', ' ')
      .replaceAll('<e>', ' ')
      .replaceAll('<b>', ' ')
      .replaceAll(' ', '  ');
  }
  const fetchListRelation = async (pageNumber: number) => {
    setLoading(true);
    try {
      await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/Admin/ListRelation?size=${pageSize}&page=${pageNumber}&lawtype=8&repealed=false`,
      )
        .then((res) => res.json())

        .then((data) => {
          setListRelation(data.data), setPageCount(data.count);
        })
        .finally(() => setLoading(false));
    } catch (error) {
      console.log('error', error);
    }
  };

  const fetchStatus = async () => {
    await fetch(`${process.env.REACT_APP_BASE_URL}/api/Data/Status?all=true`)
      .then((res) => res.json())
      .then((data) => setAllStatus(data));
  };

  const fetchAllLawList = async () => {
    await fetch(`${process.env.REACT_APP_BASE_URL}/api/Admin/ListLaw?size=30`, {
      // headers: {
      //   Authorization: `Bearer ${tokenLogin.data?.accessToken}`,
      // },
    })
      .then((res) => res.json())
      .then((data) => {
        return setLawList(data.data), setReLawList(data.data);
      });
  };
  useEffect(() => {
    fetchStatus();
    fetchAllLawList();
    fetchSearchStatus();
  }, []);
  // useEffect(()=>{
  //   fetchListRelation(page ? page : 1);
  // },[page,pageSize])
  useEffect(() => {
    // if (tokenLogin) {
    // if (!isTokenExpired(tokenLogin.data?.accessToken)) {

    // if (!isReplatedChecked || isReplatedChecked !== 'null') {
    if (
      Search !== '' ||
      whole !== 'null' ||
      confirm !== 'null' ||
      statusSearch !== 0 ||
      fromDate !== null ||
      ToDate !== null ||
      Type !== null ||
      isTitleFault !== 2 ||
      isReplatedChecked !== null
    ) {
      MainSaerchFun();
    } else {
      fetchListRelation(page ? page : 1);
      setSearchResult([]);
    }
    // } else {
    //   MainSaerchFun();
    // }
    // fetchListRelation(page ? page : 1);
    // MainSaerchFun()
  }, [
    pageSize,
    // checked,
    tokenLogin,
    // fromDate,
    // ToDate,
    // isReplatedChecked,
    // isTitleFault,
    // statusSearch,
    // confirm,
    // whole,
    // Type,
    page,

    // loading
  ]);

  let rowNumber = page ? (page - 1) * pageSize : 0;

  const onChagngePage = ({ selected }) => {
    setsearchParams({ page: selected + 1 });

    setSavePage(selected + 1);
  };
  const onChagngePageSearchResult = (data: any) => {
    setsearchParams({ page: data.selected + 1 });
    setPageNum(data.selected + 1);
    setSavePage(data.selected + 1);
  };
  // console.log("listRelation",SearchResult)
  const EditListRelation = (item: {}) => {
    // console.log('item', item);
    setObjectEdit(item);

    fetchListSection(item.Law_ID,item.Section_ID);
  console.log("listSection",listSections)
    // const x = listSections.find((r) => r.ID === item.Section_ID);
    // console.log('section find', x);
    fetchListReSection(item.reLaw_ID);
    setcaseData({
      // ...caseData,
      ID: item.ID,
      reLaw_ID: item.reLaw_ID !== null ? item.reLaw_ID : '',
      reSection_ID: item.reSection_ID !== null ? item.reSection_ID : '',
      Law_ID: item.Law_ID !== null ? item.Law_ID : '',
      Section_ID: item.Section_ID !== null ? item.Section_ID : '',
      Status_ID: item.EffectType_ID,
      isChecked: item.isChecked !== null ? item.isChecked : '',
      ExpireDate: item.ExpireDate !== null ? item.ExpireDate : '',
      FinalSectionText:
        item.FinalSectionText !== null ? item.FinalSectionText : '',
      ChangeText: item.ChangeText !== null ? item.ChangeText : '',
      withSub:
        item.WithSubset !== undefined || item.WithSubset !== null
          ? item.WithSubset
          : false,
      sectionChangeID: item.SectionChange_ID,
      description:
        item.Comment !== null || item.Comment !== undefined ? item.Comment : '',
      TextOrder: item.TextOrder !== null ? item.TextOrder : '',
      TextOrder2: item.TextOrder !== null ? item.TextOrder2 : '',
    });
    // setTextOrderListSection(x);

    setOpen(true);
  };
  const handleChangeStatus = (e: any) => {
    setcaseData({
      ...caseData,
      Status_ID: parseInt(e.target.value),
    });
  };
  const handleisTitleFault = (e) => {
    setChecked(false);
    if (e.target.value === 'null') {
      setIsTitleFault(null);
    } else {
      setIsTitleFault(Number(e.target.value));
      setSavePage(1);
      setSearchResult([]);
      setSearchResultCount(1);
    }
  };
  const handleWhole = (e) => {
    // console.log(e.target.value);
    setChecked(false);
    if (e.target.value === 'null') {
      setWhole('null');
    } else {
      setWhole(e.target.value);
      setSavePage(1);
      setSearchResult([]);
      setSearchResultCount(1);
    }
  };
  const handleFromDate = (date: any) => {
    if (date !== null) {
      setFromDate(jalaliFormat(new Date(date), 'yyyy/MM/dd'));
    } else {
      setFromDate(null);
      setSavePage(1);
      setSearchResult([]);
      setSearchResultCount(1);
    }
  };
  const handleToDate = (date: any) => {
    if (date !== null) {
      setToDate(jalaliFormat(new Date(date), 'yyyy/MM/dd'));
    } else {
      setToDate(null);
      setSavePage(1);
      setSearchResult([]);
      setSearchResultCount(1);
    }
  };

  const handleConfirm = (e) => {
    if (e.target.value === 'null') {
      setConfirm('null');
    } else {
      setConfirm(e.target.value);
      setSavePage(1);
      setSearchResult([]);
      setSearchResultCount(1);
    }
  };
  const handleType = (e) => {
    if (e.target.value === 'null') {
      setType(null);
    } else {
      setType(Number(e.target.value));
      setSavePage(1);
      setSearchResult([]);
      setSearchResultCount(1);
    }
  };
  const onchangeSearch = (e: any) => {
    setChecked(false);
    setSearch(e.target.value);
    // if (e.target.value === '') {
    //   ;
    //   // fetchListRelation(page=1)
    // }

    // setSearchPage(null)
    // setsearchParams({ page: 1 })
  };
  const onChangeIsChecked = (e: any) => {
    console.log(e.target.value);
    if (e.target.value === 'null') {
      setcaseData((caseData:{}) => ({ ...caseData, isChecked: null }));
    } else if (e.target.value === '0') {
      setcaseData((caseData:{}) => ({ ...caseData, isChecked: 0 }));
    } else if (e.target.value === '1') {
      setcaseData((caseData:{}) => ({ ...caseData, isChecked: 1 }));
    } else {
      setcaseData((caseData:{}) => ({ ...caseData, isChecked: 2 }));
    }
  };
  const x = Math.ceil(pageCount / 10);
  // console.log(pageCount,x)

  const fetchEdit = async () => {
    // console.log('token', isTokenExpired(tokenLogin.data?.accessToken));
    console.log('caseDataEdite', caseData);

    if (!isTokenExpired(tokenLogin.data?.accessToken)) {
      if (
        caseData.isChecked === 0 ||
        caseData.isChecked === 1 ||
        caseData.isChecked === 2
      ) {
        // console.log('caseDataEdite', caseData.isChecked);
        // if (caseData.Section_ID !== null) {
        let config = {
          method: 'post',
          maxBodyLength: Infinity,
          url: `${process.env.REACT_APP_BASE_URL}/api/Admin/EditRelation?ID=${
            caseData.ID
          }&Law_ID=${caseData.Law_ID}${
            caseData.Section_ID !== null
              ? '&Section_ID=' + caseData.Section_ID
              : ''
          }&reSection_ID=${caseData.reSection_ID}&reLaw_ID=${
            caseData.reLaw_ID
          }&status=${caseData.Status_ID}${
            caseData.ExpireDate !== '' && caseData.ExpireDate !== null
              ? '&ExpireDate=' + caseData.ExpireDate
              : ''
          }&isChecked=${caseData.isChecked}${
            caseData.ChangeText !== ''
              ? '&ChangeText=' + caseData.ChangeText
              : ''
          }${
            caseData.withSub !== undefined && caseData.withSub !== null
              ? '&WithSubset=' + caseData.withSub
              : ''
          }${
            caseData.description !== undefined && caseData.description !== ''
              ? '&Comment=' + caseData.description
              : ''
          }${
            caseData.TextOrder !== undefined && caseData.TextOrder !== null
              ? '&TextOrder=' + caseData.TextOrder
              : ''
          }${
            caseData.TextOrder2 !== undefined && caseData.TextOrder2 !== null
              ? '&TextOrder2=' + caseData.TextOrder2
              : ''
          }`,
          headers: {
            Authorization: `Bearer ${tokenLogin.data?.accessToken}`,
            'Content-Type': 'application/json',
            // 'Access-Control-Allow-Origin': '*',
            // 'Access-Control-Allow-Methods': 'GET,OPTIONS,PATCH,DELETE,POST,PUT',
            // 'Access-Control-Allow-Headers':
            //   'X-Requested-With, Content-Type, Authorization',
            // 'Access-Control-Allow-Credentials': 'true',
          },
          data: JSON.stringify(caseData.FinalSectionText),
        };
        await axios.request(config).then((res) => {
          if (res.status === 401) {
            // fetchRefreshToken();
          } else {
            // if (
            //   (Search !== '' ||
            //     whole !== 'null' ||
            //     // isTitleFault !== 'null' &&
            //     statusSearch !== 0) ||
            //   (Search !== '' && whole !== 'null' && statusSearch !== 0) ||
            //   (Search !== '' && whole !== '') ||
            //   (statusSearch !== 0 &&
            //     // isTitleFault !== 'null' &&
            //     whole !== 'null') ||
            //   // (Search !== '' && isTitleFault !== 'null') ||
            //   (Search !== '' && whole !== 'null') ||
            //   (Search !== '' && statusSearch !== 0) ||
            //   (statusSearch !== 0 && isTitleFault !== null) ||
            //   (statusSearch !== 0 && whole !== 'null') ||
            //   // (isTitleFault !== 'null' && whole !== 'null') ||
            //   Search !== '' ||
            //   statusSearch !== 0 ||
            //   // isTitleFault !== 'null' ||
            //   whole !== 'null'
            // ) {
            //   MainSaerchFun();
            // } else {
            //   fetchListRelation(page ? page : 1);
            // }
            // if (res.status == 200) {

            if (
              isTitleFault !== null ||
              whole !== null ||
              confirm !== 'null' ||
              Search !== '' ||
              statusSearch !== 0 ||
              Type !== null ||
              fromDate !== null ||
              ToDate !== null ||
              isReplatedChecked !== null
            ) {
              MainSaerchFun();
            } else {
              fetchListRelation(page ? page : 1);
            }
            alert('اطلاعات با موفقیت ثبت شد ');
            setcaseData({
              ID: 0,
              reLaw_ID: 0,
              reSection_ID: 0 || null,
              Law_ID: 0,
              Section_ID: 0 || null,
              Status_ID: 0,
              isChecked: null,
              ExpireDate: '',
              FinalSectionText: '',
              ChangeText: '',
              withSub: false,
              sectionChangeID: null,
            });
            // }
            setOpen(false);
          }
        });
        // }
        // else {
        //   let config = {
        //     method: 'post',
        //     maxBodyLength: Infinity,
        //     url: `${process.env.REACT_APP_BASE_URL}/api/Admin/EditRelation?ID=${
        //       caseData.ID
        //     }&Law_ID=${caseData.Law_ID}&Section_ID=&reSection_ID=${
        //       caseData.reSection_ID
        //     }&reLaw_ID=${caseData.reLaw_ID}&status=${caseData.Status_ID}${
        //       caseData.ExpireDate !== ''
        //         ? '&ExpireDate=' + caseData.ExpireDate
        //         : ''
        //     }&isChecked=${caseData.isChecked}${
        //       caseData.ChangeText !== ''
        //         ? '&ChangeText=' + caseData.ChangeText
        //         : ''
        //     }}${caseData.withSub!==undefined ?'&WithSubset='+ caseData.withSub : ''}${
        //       caseData.description !== '' || caseData.description !== "undefined"
        //         ? '&Comment=' + caseData.description
        //         : ''
        //     }`,

        //     headers: {
        //       Authorization: `Bearer ${tokenLogin.data?.accessToken}`,
        //       'Content-Type': 'application/json',
        //       // 'Access-Control-Allow-Origin': '*',
        //       // 'Access-Control-Allow-Methods': 'GET,OPTIONS,PATCH,DELETE,POST,PUT',
        //       // 'Access-Control-Allow-Headers':
        //       //   'X-Requested-With, Content-Type, Authorization',
        //       // 'Access-Control-Allow-Credentials': 'true',
        //     },
        //     data: JSON.stringify(caseData.FinalSectionText),
        //   };

        //   await axios.request(config).then((res) => {
        //     if (res.status === 401) {
        //       // fetchRefreshToken();
        //     } else {

        //       if (
        //         isTitleFault !== null ||
        //         whole !== null ||
        //         confirm !== 'null' ||
        //         Search !== '' ||
        //         statusSearch !== 0 ||
        //         Type !== null ||
        //         fromDate !== null ||
        //         ToDate !== null ||
        //         isReplatedChecked !== null
        //       ) {
        //         MainSaerchFun();
        //       } else {
        //         fetchListRelation(page ? page : 1);
        //       }
        //       alert('اطلاعات با موفقیت ثبت شد ');
        //       setcaseData({
        //         ID: 0,
        //         reLaw_ID: 0,
        //         reSection_ID: 0 || null,
        //         Law_ID: 0,
        //         Section_ID: 0 || null,
        //         Status_ID: 0,
        //         isChecked: null,
        //         ExpireDate: null,
        //         FinalSectionText: '',
        //         ChangeText: '',
        //         withSub: false,
        //       });
        //       // }
        //       setOpen(false);
        //     }
        //   });
        // }
      } else {
        // console.log('caseDataEditefetch', caseData.Section_ID);
        if (caseData.Section_ID !== null) {
          let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${process.env.REACT_APP_BASE_URL}/api/Admin/EditRelation?ID=${
              caseData.ID
            }&Law_ID=${caseData.Law_ID}${
              caseData.description !== undefined && caseData.description !== ''
                ? '&Comment=' + caseData.description
                : ''
            }&Section_ID=${caseData.Section_ID}&reSection_ID=${
              caseData.reSection_ID
            }&reLaw_ID=${caseData.reLaw_ID}&status=${caseData.Status_ID}${
              caseData.ExpireDate !== '' && caseData.ExpireDate !== null
                ? '&ExpireDate=' + caseData.ExpireDate
                : ''
            }&ChangeText=${caseData.ChangeText}${
              caseData.withSub !== undefined && caseData.withSub !== null
                ? '&WithSubset=' + caseData.withSub
                : ''
            }${
              caseData.TextOrder !== undefined && caseData.TextOrder !== null
                ? '&TextOrder=' + caseData.TextOrder
                : ''
            }${
              caseData.TextOrder2 !== undefined && caseData.TextOrder2 !== null
                ? '&TextOrder2=' + caseData.TextOrder2
                : ''
            }`,

            headers: {
              Authorization: `Bearer ${tokenLogin.data?.accessToken}`,
              'Content-Type': 'application/json',
              // 'Access-Control-Allow-Origin': '*',
              // 'Access-Control-Allow-Methods': 'GET,OPTIONS,PATCH,DELETE,POST,PUT',
              // 'Access-Control-Allow-Headers':
              //   'X-Requested-With, Content-Type, Authorization',
              // 'Access-Control-Allow-Credentials': 'true',
            },
            data: JSON.stringify(caseData.FinalSectionText),
          };

          await axios.request(config).then((res) => {
            if (res.status === 401) {
            } else {
              if (
                isTitleFault !== null ||
                whole !== null ||
                confirm !== 'null' ||
                Search !== '' ||
                statusSearch !== 0 ||
                Type !== null ||
                fromDate !== null ||
                ToDate !== null ||
                isReplatedChecked !== null
              ) {
                MainSaerchFun();
              } else {
                fetchListRelation(page ? page : 1);
              }
              alert('اطلاعات با موفقیت ثبت شد ');
              setcaseData({
                ID: 0,
                reLaw_ID: 0,
                reSection_ID: 0 || null,
                Law_ID: 0,
                Section_ID: 0 || null,
                Status_ID: 0,
                isChecked: null,
                ExpireDate: null,
                FinalSectionText: '',
                ChangeText: '',
                withSub: false,
              });
              // }
              setOpen(false);
            }
          });
        } else {
          // console.log('caseData.sectionID === null');

          let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${process.env.REACT_APP_BASE_URL}/api/Admin/EditRelation?ID=${
              caseData.ID
            }&Law_ID=${caseData.Law_ID}&reSection_ID=${
              caseData.reSection_ID
            }&reLaw_ID=${caseData.reLaw_ID}&status=${caseData.Status_ID}${
              caseData.ExpireDate !== '' && caseData.ExpireDate !== null
                ? '&ExpireDate=' + caseData.ExpireDate
                : ''
            }&ChangeText=${caseData.ChangeText}${
              caseData.withSub !== undefined && caseData.withSub !== null
                ? '&WithSubset=' + caseData.withSub
                : ''
            }${
              caseData.description !== undefined && caseData.description !== ''
                ? '&Comment=' + caseData.description
                : ''
            }${
              caseData.TextOrder !== undefined && caseData.TextOrder !== null
                ? '&TextOrder=' + caseData.TextOrder
                : ''
            }${
              caseData.TextOrder2 !== undefined && caseData.TextOrder2 !== null
                ? '&TextOrder2=' + caseData.TextOrder2
                : ''
            }`,

            headers: {
              Authorization: `Bearer ${tokenLogin.data?.accessToken}`,
              'Content-Type': 'application/json',
              // 'Access-Control-Allow-Origin': '*',
              // 'Access-Control-Allow-Methods': 'GET,OPTIONS,PATCH,DELETE,POST,PUT',
              // 'Access-Control-Allow-Headers':
              //   'X-Requested-With, Content-Type, Authorization',
              // 'Access-Control-Allow-Credentials': 'true',
            },
            data: JSON.stringify(caseData.FinalSectionText),
          };

          await axios.request(config).then((res) => {
            if (res.status === 401) {
              // fetchRefreshToken();
            } else {
              // if (
              //   (Search !== '' &&
              //     whole !== 'null' &&
              //     // isTitleFault !== 'null' &&
              //     statusSearch !== 0) ||
              //   (Search !== '' && whole !== 'null' && statusSearch !== 0) ||
              //   (Search !== '' && whole !== '') ||
              //   (statusSearch !== 0 && whole !== 'null') ||
              //   // (Search !== '' && isTitleFault !== 'null') ||
              //   (Search !== '' && whole !== 'null') ||
              //   (Search !== '' && statusSearch !== 0) ||
              //   // (statusSearch !== 0 && isTitleFault !== 'null') ||
              //   (statusSearch !== 0 && whole !== 'null') ||
              //   // (isTitleFault !== 'null' && whole !== 'null') ||
              //   Search !== '' ||
              //   statusSearch !== 0 ||
              //   // isTitleFault !== 'null' ||
              //   whole !== 'null'
              // ) {
              //   // SearchFun();
              //   MainSaerchFun();
              // } else {
              //   fetchListRelation(page ? page : 1);
              // }
              // if (res.status == 200) {
              //   alert('اطلاعات با موفقیت ثبت شد ');
              // }
              // setOpen(false);
              if (
                isTitleFault !== null ||
                whole !== null ||
                confirm !== 'null' ||
                Search !== '' ||
                statusSearch !== 0 ||
                Type !== null ||
                fromDate !== null ||
                ToDate !== null ||
                isReplatedChecked !== null
              ) {
                MainSaerchFun();
              } else {
                fetchListRelation(page ? page : 1);
              }
              alert('اطلاعات با موفقیت ثبت شد ');
              setcaseData({
                ID: 0,
                reLaw_ID: 0,
                reSection_ID: 0 || null,
                Law_ID: 0,
                Section_ID: 0 || null,
                Status_ID: 0,
                isChecked: null,
                ExpireDate: '',
                FinalSectionText: '',
                ChangeText: '',
                withSub: false,
              });
              // }
              setOpen(false);
            }
          });
        }
      }
    } else {
      fetchRefreshToken();
    }
  };

  const handleChangeSearchStatus = (e) => {
    // setChecked(false);
    // console.log(e.target.value);
    if (e.target.value === '0') {
      setStatusSearch(0);
      //
    } else {
      setStatusSearch(e.target.value);
    }
  };

  const fetchDelete = () => {
    if (!isTokenExpired(tokenLogin.data?.accessToken)) {
      fetch(
        `${process.env.REACT_APP_BASE_URL}/api/Admin/DeleteRelation?ID=${objectEdit}`,
        {
          headers: {
            Authorization: `Bearer ${tokenLogin.data?.accessToken}`,
          },
        },
      )
        .then((res) => {
          console.log(res);
          fetchListRelation(page ? page : 1);
          setOpenDeleteModal(false);
        })
        .catch((error) => {})
        .finally(() => setLoading(false));
    } else {
      fetchRefreshToken();
    }
    // } else {
    //   window.location.assign('/');
    // }
  };
  const handleDelete = (item: {}) => {
    setOpenDeleteModal(true);
    setObjectEdit(item.LawRelation_ID);
    // console.log("item",item.LawRelation_ID)
  };

  const handlerChangeSection = (e: any) => {
    const x = listSections.find((r) => r.ID === parseInt(e.target.value));
    setTextOrderListSection(x);
    // console.log('section', e.target.value);
    if (e.target.value === 'null') {
      setcaseData({
        ...caseData,
        Section_ID: null,
      });
    } else if (e.target.value === '0') {
      setcaseData({
        ...caseData,
        Section_ID: 0,
      });
    } else {
      setcaseData({
        ...caseData,
        Section_ID: parseInt(e.target.value),
      });
      
    }
    
  };
  const handlerChangereSection = (e: any) => {
    // if (e.target.value === 'null') {
    //   setcaseData({
    //     ...caseData,
    //     reSection_ID: null,
    //   });
    // } else
    if (e.target.value === '0') {
      setcaseData({
        ...caseData,
        reSection_ID: 0,
      });
    } else {
      setcaseData({
        ...caseData,
        reSection_ID: parseInt(e.target.value),
      });
    }
  };
  const handleChangeSize = (e) => {
    // console.log('size', e.target.value);
    if (page !== 1) {
      setsearchParams({});
      setPageSize(parseInt(e.target.value));
    } else {
      setPageSize(parseInt(e.target.value));
    }
    // fetchListRelation(page=1)
    // if (e.target.value === "null") {
    //   setPageSize(10)
    // }
    // else {
    //   setPageSize(parseInt(e.target.value))
    // }
  };
  const MainSaerchFun = async () => {
    if (
      isTitleFault !== null ||
      whole !== null ||
      confirm !== 'null' ||
      Search !== '' ||
      statusSearch !== 0 ||
      Type !== null ||
      fromDate !== null ||
      ToDate !== null ||
      isReplatedChecked !== null
    ) {
      setLoading(true);
      try {
        await fetch(
          `${
            process.env.REACT_APP_BASE_URL
          }/api/Admin/ListRelation?size=${pageSize}&page=${
            pageNum !== null ? pageNum : 1
          }${Search !== '' ? '&search=' + Search : ''}${
            whole !== 'null' ? '&whole=' + whole : ''
          }${isTitleFault !== null ? '&isTitleFault=' + isTitleFault : ''}${
            confirm !== 'null' ? '&confirm=' + confirm : ''
          }${statusSearch !== 0 ? '&status=' + statusSearch : ''}${
            Type !== null ? '&lawtype=' + Type : ''
          }${fromDate !== null ? '&fromDate=' + fromDate : ''}${
            ToDate !== null ? '&toDate=' + ToDate : ''
          }${
            isReplatedChecked !== null ? '&repealed=' + isReplatedChecked : ''
          }`,
        )
          .then((res) => res.json())
          .then((data) => {
            setSearchResult(data.data), setSearchResultCount(data.count);
            setClickBtn(true);
          })
          .finally(() => setLoading(false));
      } catch (error) {
        console.log('error', error);
      }
    } else {
      fetchListRelation(page ? page : 1);
    }
  };
  const handleChangSizeSearch = (e) => {
    if (searchParams.size === 1) {
      setPageSize(parseInt(e.target.value));
      MainSaerchFun();
    } else {
      setPageSize(parseInt(e.target.value));
      MainSaerchFun();
    }
  };

  const handleCheck = (e) => {
    // console.log(SearchResultCount);
    setChecked(e.target.checked);
    if (e.target.checked === true) {
      setPageSize(SearchResultCount);
    } else {
      setPageSize(30);
    }
  };
  const ClickAndOpenReform = (id) => {
    setLoading(true);
    try {
      fetch(
        `${process.env.REACT_APP_BASE_URL}/api/Admin/ListSection?sectionid=${id}`,
      )
        .then((res) => res.json())
        .then((data) => {
          console.log(data.data);
          setReformInfo({
            ID: data.data[0].ID,
            Parent_ID: data.data[0].Parent_ID,
            Law_ID: data.data[0].Law_ID,
            SectionText: data.data[0].SectionText,
            Title: data.data[0].Title,
            SectionType_ID: data.data[0].SectionType_ID,
            TextOrder: data.data[0].TextOrder,
            TextOrder2: data.data[0].TextOrder2,
            SectionNumber: data.data[0].SectionNumber,
            LetterNumber: data.data[0].LetterNumber,
            // SectionTitle: data.data.SectionTitle,
            TextForEdit: '',

            // RevisionRistrict: true,
            ChangeDate:
              data.data[0].ChangeDate !== '' || data.data[0].ChangeDate !== null
                ? data.data[0].ChangeDate
                : '',
            Status: data.data[0].Status_ID,
            SectionPath: data.data[0].SectionPath,
          });
          setOpenEditModal(true);
          setOpen(false);
          setCreateModal(false);
          fetchLops(data.data[0].Law_ID);
          setLoading(false);
        });
    } catch (error) {}
  };
  // console.log(ReformInfo)
  // const CreateInfo = async () => {
  //   // if (tokenLogin) {
  //   // if (!isTokenExpired(tokenLogin.data?.accessToken)) {
  //   if (!isTokenExpired(tokenLogin.data?.accessToken)) {
  //     if (
  //       caseData.isChecked === 0 ||
  //       caseData.isChecked === 1 ||
  //       caseData.isChecked === 2
  //     ) {
  //       // console.log('caseDataEdite', caseData.isChecked);
  //       if (caseData.Section_ID !== null) {
  //         let config = {
  //           method: 'post',
  //           maxBodyLength: Infinity,
  //           url: `${process.env.REACT_APP_BASE_URL}/api/Admin/EditRelation?ID=${caseData.ID}&Law_ID=${caseData.Law_ID}&Section_ID=${caseData.Section_ID}&reSection_ID=${caseData.reSection_ID}&reLaw_ID=${caseData.reLaw_ID}&status=${caseData.Status_ID}&ExpireDate=${caseData.ExpireDate}&isChecked=${caseData.isChecked}&ChangeText=${caseData.ChangeText}&WithSubset=${caseData.withSub}${caseData.description!==undefined ? '&Comment='+caseData.description:''}`,

  //           headers: {
  //             Authorization: `Bearer ${tokenLogin.data?.accessToken}`,
  //             'Content-Type': 'application/json',
  //             // 'Access-Control-Allow-Origin': '*',
  //             // 'Access-Control-Allow-Methods': 'GET,OPTIONS,PATCH,DELETE,POST,PUT',
  //             // 'Access-Control-Allow-Headers':
  //             //   'X-Requested-With, Content-Type, Authorization',
  //             // 'Access-Control-Allow-Credentials': 'true',
  //           },
  //           data: JSON.stringify(caseData.FinalSectionText),
  //         };
  //         await axios.request(config).then((res) => {
  //           if (res.status === 401) {
  //             // fetchRefreshToken();
  //           } else {
  //             if (
  //               (Search !== '' &&
  //                 whole !== 'null' &&
  //                 isTitleFault !== null &&
  //                 statusSearch !== 0) ||
  //               (Search !== '' && whole !== 'null' && statusSearch !== 0) ||
  //               (Search !== '' && isTitleFault !== null && whole !== '') ||
  //               (statusSearch !== 0 &&
  //                 isTitleFault !== null &&
  //                 whole !== 'null') ||
  //               (Search !== '' && isTitleFault !== null) ||
  //               (Search !== '' && whole !== 'null') ||
  //               (Search !== '' && statusSearch !== 0) ||
  //               (statusSearch !== 0 && isTitleFault !== null) ||
  //               (statusSearch !== 0 && whole !== 'null') ||
  //               (isTitleFault !== null && whole !== 'null') ||
  //               Search !== '' ||
  //               statusSearch !== 0 ||
  //               isTitleFault !== null ||
  //               whole !== 'null'
  //             ) {
  //               MainSaerchFun();
  //             } else {
  //               fetchListRelation(page ? page : 1);
  //             }
  //             if (res.status == 200) {
  //               alert('اطلاعات با موفقیت ثبت شد ');
  //               setcaseData({
  //                 ID: 0,
  //                 reLaw_ID: 0,
  //                 reSection_ID: 0 || null,
  //                 Law_ID: 0,
  //                 Section_ID: 0 || null,
  //                 Status_ID: 0,
  //                 isChecked: null,
  //                 ExpireDate: null,
  //                 FinalSectionText: '',
  //                 ChangeText: '',
  //                 withSub: false,
  //               });
  //             }
  //             setOpen(false);
  //           }
  //         });

  //         // fetch(
  //         //   `${process.env.REACT_APP_BASE_URL}/api/Admin/EditRelation?ID=${caseData.ID}&Law_ID=${caseData.Law_ID}&Section_ID=${caseData.Section_ID}&reSection_ID=${caseData.reSection_ID}&reLaw_ID=${caseData.reLaw_ID}&status=${caseData.Status_ID}&FinalText=${caseData.FinalSectionText}&ExpireDate=${caseData.ExpireDate}&isChecked=${caseData.isChecked}&ChangeText=${caseData.ChangeText}&WithSubset=${caseData.withSub}`,
  //         //   {
  //         //     // mode: 'no-cors',
  //         //     method: 'POST',
  //         //     headers: {
  //         //       Authorization: `Bearer ${tokenLogin.data?.accessToken}`,
  //         //     },
  //         //   },
  //         // ).then((res) => {
  //         //   console.log(res);
  //         //   if (res.status === 401) {
  //         //     // fetchRefreshToken();
  //         //   } else {
  //         //     if (
  //         //       (Search !== '' &&
  //         //         whole !== 'null' &&
  //         //         isTitleFault !== 'null' &&
  //         //         statusSearch !== 0) ||
  //         //       (Search !== '' && whole !== 'null' && statusSearch !== 0) ||
  //         //       (Search !== '' && isTitleFault !== 'null' && whole !== '') ||
  //         //       (statusSearch !== 0 &&
  //         //         isTitleFault !== 'null' &&
  //         //         whole !== 'null') ||
  //         //       (Search !== '' && isTitleFault !== 'null') ||
  //         //       (Search !== '' && whole !== 'null') ||
  //         //       (Search !== '' && statusSearch !== 0) ||
  //         //       (statusSearch !== 0 && isTitleFault !== 'null') ||
  //         //       (statusSearch !== 0 && whole !== 'null') ||
  //         //       (isTitleFault !== 'null' && whole !== 'null') ||
  //         //       Search !== '' ||
  //         //       statusSearch !== 0 ||
  //         //       isTitleFault !== 'null' ||
  //         //       whole !== 'null'
  //         //     ) {
  //         //       SearchFun();
  //         //     } else {
  //         //       fetchListRelation(page ? page : 1);
  //         //     }
  //         //     // setOpen(false);
  //         //     alert("اطلاعات شما با موفقیت ثبت شد ")
  //         //   }
  //         // });
  //       } else {
  //         let config = {
  //           method: 'post',
  //           maxBodyLength: Infinity,
  //           url: `${process.env.REACT_APP_BASE_URL}/api/Admin/EditRelation?ID=${caseData.ID}&Law_ID=${caseData.Law_ID}&Section_ID=&reSection_ID=${caseData.reSection_ID}&reLaw_ID=${caseData.reLaw_ID}&status=${caseData.Status_ID}&ExpireDate=${caseData.ExpireDate}&isChecked=${caseData.isChecked}&ChangeText=${caseData.ChangeText}&WithSubset=${caseData.withSub}&Comment=${caseData.description}`,

  //           headers: {
  //             Authorization: `Bearer ${tokenLogin.data?.accessToken}`,
  //             'Content-Type': 'application/json',
  //             // 'Access-Control-Allow-Origin': '*',
  //             // 'Access-Control-Allow-Methods': 'GET,OPTIONS,PATCH,DELETE,POST,PUT',
  //             // 'Access-Control-Allow-Headers':
  //             //   'X-Requested-With, Content-Type, Authorization',
  //             // 'Access-Control-Allow-Credentials': 'true',
  //           },
  //           data: JSON.stringify(caseData.FinalSectionText),
  //         };
  //         await axios.request(config).then((res) => {
  //           if (res.status === 401) {
  //             // fetchRefreshToken();
  //           } else {
  //             if (
  //               (Search !== '' &&
  //                 whole !== 'null' &&
  //                 isTitleFault !== null &&
  //                 statusSearch !== 0) ||
  //               (Search !== '' && whole !== 'null' && statusSearch !== 0) ||
  //               (Search !== '' && isTitleFault !== null && whole !== '') ||
  //               (statusSearch !== 0 &&
  //                 isTitleFault !== null &&
  //                 whole !== 'null') ||
  //               (Search !== '' && isTitleFault !== null) ||
  //               (Search !== '' && whole !== 'null') ||
  //               (Search !== '' && statusSearch !== 0) ||
  //               (statusSearch !== 0 && isTitleFault !== null) ||
  //               (statusSearch !== 0 && whole !== 'null') ||
  //               (isTitleFault !== null && whole !== 'null') ||
  //               Search !== '' ||
  //               statusSearch !== 0 ||
  //               isTitleFault !== null ||
  //               whole !== 'null'
  //             ) {
  //               // SearchFun();
  //               MainSaerchFun();
  //             } else {
  //               fetchListRelation(page ? page : 1);
  //             }
  //             if (res.status == 200) {
  //               alert('اطلاعات با موفقیت ثبت شد ');
  //               setcaseData({
  //                 ID: 0,
  //                 reLaw_ID: 0,
  //                 reSection_ID: 0 || null,
  //                 Law_ID: 0,
  //                 Section_ID: 0 || null,
  //                 Status_ID: 0,
  //                 isChecked: null,
  //                 ExpireDate: null,
  //                 FinalSectionText: '',
  //                 ChangeText: '',
  //                 withSub: false,
  //               });
  //             }
  //             setOpen(false);
  //           }
  //         });
  //         // fetch(
  //         //   `${process.env.REACT_APP_BASE_URL}/api/Admin/EditRelation?ID=${caseData.ID}&Law_ID=${caseData.Law_ID}&Section_ID=&reSection_ID=${caseData.reSection_ID}&reLaw_ID=${caseData.reLaw_ID}&status=${caseData.Status_ID}&FinalText=${caseData.FinalSectionText}&ExpireDate=${caseData.ExpireDate}&isChecked=${caseData.isChecked}&ChangeText=${caseData.ChangeText}&WithSubset=${caseData.withSub}`,
  //         //   {
  //         //     // mode: 'no-cors',
  //         //     method: 'POST',
  //         //     headers: {
  //         //       Authorization: `Bearer ${tokenLogin.data?.accessToken}`,
  //         //     },
  //         //   },
  //         // ).then((res) => {
  //         //   console.log(res);
  //         //   if (res.status === 401) {
  //         //     // fetchRefreshToken();
  //         //   } else {
  //         //     if (
  //         //       (Search !== '' &&
  //         //         whole !== 'null' &&
  //         //         isTitleFault !== 'null' &&
  //         //         statusSearch !== 0) ||
  //         //       (Search !== '' && whole !== 'null' && statusSearch !== 0) ||
  //         //       (Search !== '' && isTitleFault !== 'null' && whole !== '') ||
  //         //       (statusSearch !== 0 &&
  //         //         isTitleFault !== 'null' &&
  //         //         whole !== 'null') ||
  //         //       (Search !== '' && isTitleFault !== 'null') ||
  //         //       (Search !== '' && whole !== 'null') ||
  //         //       (Search !== '' && statusSearch !== 0) ||
  //         //       (statusSearch !== 0 && isTitleFault !== 'null') ||
  //         //       (statusSearch !== 0 && whole !== 'null') ||
  //         //       (isTitleFault !== 'null' && whole !== 'null') ||
  //         //       Search !== '' ||
  //         //       statusSearch !== 0 ||
  //         //       isTitleFault !== 'null' ||
  //         //       whole !== 'null'
  //         //     ) {
  //         //       SearchFun();
  //         //     } else {
  //         //       fetchListRelation(page ? page : 1);
  //         //     }
  //         //     alert("اطلاعات شما با موفقیت ثبت شد ")
  //         //   }
  //         // });
  //       }
  //     } else {
  //       // console.log('caseDataEditefetch', caseData.Section_ID);
  //       if (caseData.Section_ID !== null) {
  //         let config = {
  //           method: 'post',
  //           maxBodyLength: Infinity,
  //           url: `${process.env.REACT_APP_BASE_URL}/api/Admin/EditRelation?ID=${caseData.ID}&Law_ID=${caseData.Law_ID}&Section_ID=&reSection_ID=${caseData.reSection_ID}&reLaw_ID=${caseData.reLaw_ID}&status=${caseData.Status_ID}&ExpireDate=${caseData.ExpireDate}&ChangeText=${caseData.ChangeText}&isChecked=&WithSubset=${caseData.withSub}&Comment=${caseData.description}`,

  //           headers: {
  //             Authorization: `Bearer ${tokenLogin.data?.accessToken}`,
  //             'Content-Type': 'application/json',
  //             // 'Access-Control-Allow-Origin': '*',
  //             // 'Access-Control-Allow-Methods': 'GET,OPTIONS,PATCH,DELETE,POST,PUT',
  //             // 'Access-Control-Allow-Headers':
  //             //   'X-Requested-With, Content-Type, Authorization',
  //             // 'Access-Control-Allow-Credentials': 'true',
  //           },
  //           data: JSON.stringify(caseData.FinalSectionText),
  //         };
  //         await axios.request(config).then((res) => {
  //           if (res.status === 401) {
  //             // fetchRefreshToken();
  //           } else {
  //             if (
  //               (Search !== '' &&
  //                 whole !== 'null' &&
  //                 isTitleFault !== null &&
  //                 statusSearch !== 0) ||
  //               (Search !== '' && whole !== 'null' && statusSearch !== 0) ||
  //               (Search !== '' && isTitleFault !== null && whole !== '') ||
  //               (statusSearch !== 0 &&
  //                 isTitleFault !== null &&
  //                 whole !== 'null') ||
  //               (Search !== '' && isTitleFault !== null) ||
  //               (Search !== '' && whole !== 'null') ||
  //               (Search !== '' && statusSearch !== 0) ||
  //               (statusSearch !== 0 && isTitleFault !== null) ||
  //               (statusSearch !== 0 && whole !== 'null') ||
  //               (isTitleFault !== null && whole !== 'null') ||
  //               Search !== '' ||
  //               statusSearch !== 0 ||
  //               isTitleFault !== null ||
  //               whole !== 'null'
  //             ) {
  //               // SearchFun();
  //               MainSaerchFun();
  //             } else {
  //               fetchListRelation(page ? page : 1);
  //             }
  //             if (res.status == 200) {
  //               alert('اطلاعات با موفقیت ثبت شد ');
  //               setcaseData({
  //                 ID: 0,
  //                 reLaw_ID: 0,
  //                 reSection_ID: 0 || null,
  //                 Law_ID: 0,
  //                 Section_ID: 0 || null,
  //                 Status_ID: 0,
  //                 isChecked: null,
  //                 ExpireDate: null,
  //                 FinalSectionText: '',
  //                 ChangeText: '',
  //                 withSub: false,
  //               });
  //             }
  //             setOpen(false);
  //           }
  //         });

  //         // fetch(
  //         //   `${process.env.REACT_APP_BASE_URL}/api/Admin/EditRelation?ID=${caseData.ID}&Law_ID=${caseData.Law_ID}&Section_ID=${caseData.Section_ID}&reSection_ID=${caseData.reSection_ID}&reLaw_ID=${caseData.reLaw_ID}&status=${caseData.Status_ID}&FinalText=${caseData.FinalSectionText}&ExpireDate=${caseData.ExpireDate}&ChangeText=${caseData.ChangeText}&isChecked=&WithSubset=${caseData.withSub}`,
  //         //   {
  //         //     // mode: 'no-cors',
  //         //     method: 'POST',
  //         //     headers: {
  //         //       Authorization: `Bearer ${tokenLogin.data?.accessToken}`,
  //         //     },
  //         //   },
  //         // ).then((res) => {
  //         //   if (res.status === 401) {
  //         //     // fetchRefreshToken();
  //         //   } else {
  //         //     console.log(res);
  //         //     if (
  //         //       (Search !== '' &&
  //         //         whole !== 'null' &&
  //         //         isTitleFault !== 'null' &&
  //         //         statusSearch !== 0) ||
  //         //       (Search !== '' && whole !== 'null' && statusSearch !== 0) ||
  //         //       (Search !== '' && isTitleFault !== 'null' && whole !== '') ||
  //         //       (statusSearch !== 0 &&
  //         //         isTitleFault !== 'null' &&
  //         //         whole !== 'null') ||
  //         //       (Search !== '' && isTitleFault !== 'null') ||
  //         //       (Search !== '' && whole !== 'null') ||
  //         //       (Search !== '' && statusSearch !== 0) ||
  //         //       (statusSearch !== 0 && isTitleFault !== 'null') ||
  //         //       (statusSearch !== 0 && whole !== 'null') ||
  //         //       (isTitleFault !== 'null' && whole !== 'null') ||
  //         //       Search !== '' ||
  //         //       statusSearch !== 0 ||
  //         //       isTitleFault !== 'null' ||
  //         //       whole !== 'null'
  //         //     ) {
  //         //       SearchFun();
  //         //     } else {
  //         //       fetchListRelation(page ? page : 1);
  //         //     }
  //         //     alert("اطلاعات شما با موفقیت ثبت شد ")
  //         //   }
  //         // });
  //       } else {
  //         // console.log('caseData.sectionID === null');
  //         let config = {
  //           method: 'post',
  //           maxBodyLength: Infinity,
  //           url: `${process.env.REACT_APP_BASE_URL}/api/Admin/EditRelation?ID=${caseData.ID}&Law_ID=${caseData.Law_ID}&Section_ID=&reSection_ID=${caseData.reSection_ID}&reLaw_ID=${caseData.reLaw_ID}&status=${caseData.Status_ID}&ExpireDate=${caseData.ExpireDate}&ChangeText=${caseData.ChangeText}&isChecked=&WithSubset=${caseData.withSub}&Comment=${caseData.description}`,

  //           headers: {
  //             Authorization: `Bearer ${tokenLogin.data?.accessToken}`,
  //             'Content-Type': 'application/json',
  //             // 'Access-Control-Allow-Origin': '*',
  //             // 'Access-Control-Allow-Methods': 'GET,OPTIONS,PATCH,DELETE,POST,PUT',
  //             // 'Access-Control-Allow-Headers':
  //             //   'X-Requested-With, Content-Type, Authorization',
  //             // 'Access-Control-Allow-Credentials': 'true',
  //           },
  //           data: JSON.stringify(caseData.FinalSectionText),
  //         };

  //         await axios.request(config).then((res) => {
  //           if (res.status === 401) {
  //             // fetchRefreshToken();
  //           } else {
  //             if (
  //               (Search !== '' &&
  //                 whole !== 'null' &&
  //                 isTitleFault !== null &&
  //                 statusSearch !== 0 &&
  //                 confirm !== 'null') ||
  //               Type !== null ||
  //               (Search !== '' && whole !== 'null' && statusSearch !== 0) ||
  //               (Search !== '' && isTitleFault !== null && whole !== '') ||
  //               (statusSearch !== 0 &&
  //                 isTitleFault !== null &&
  //                 whole !== 'null') ||
  //               (Search !== '' && isTitleFault !== null) ||
  //               (Search !== '' && whole !== 'null') ||
  //               (Search !== '' && statusSearch !== 0) ||
  //               (statusSearch !== 0 && isTitleFault !== null) ||
  //               (statusSearch !== 0 && whole !== 'null') ||
  //               (isTitleFault !== null && whole !== 'null') ||
  //               Search !== '' ||
  //               statusSearch !== 0 ||
  //               isTitleFault !== null ||
  //               whole !== 'null'
  //             ) {
  //               // SearchFun();
  //               MainSaerchFun();
  //             } else {
  //               fetchListRelation(page ? page : 1);
  //             }
  //             if (res.status == 200) {
  //               alert('اطلاعات با موفقیت ثبت شد ');
  //               setcaseData({
  //                 ID: 0,
  //                 reLaw_ID: 0,
  //                 reSection_ID: 0 || null,
  //                 Law_ID: 0,
  //                 Section_ID: 0 || null,
  //                 Status_ID: 0,
  //                 isChecked: null,
  //                 ExpireDate: null,
  //                 FinalSectionText: '',
  //                 ChangeText: '',
  //                 withSub: false,
  //               });
  //             }
  //             setOpen(false);
  //           }
  //         });

  //         // fetch(
  //         //   `${process.env.REACT_APP_BASE_URL}/api/Admin/EditRelation?ID=${caseData.ID}&Law_ID=${caseData.Law_ID}&Section_ID=&reSection_ID=${caseData.reSection_ID}&reLaw_ID=${caseData.reLaw_ID}&status=${caseData.Status_ID}&FinalText=${caseData.FinalSectionText}&ExpireDate=${caseData.ExpireDate}&ChangeText=${caseData.ChangeText}&isChecked=&WithSubset${caseData.withSub}`,
  //         //   {
  //         //     // mode: 'no-cors',
  //         //     method: 'POST',
  //         //     headers: {
  //         //       Authorization: `Bearer ${tokenLogin.data?.accessToken}`,
  //         //     },
  //         //   },
  //         // ).then((res) => {
  //         //   if (res.status === 401) {
  //         //     // fetchRefreshToken();
  //         //   } else {
  //         //     console.log(res);
  //         //     if (
  //         //       (Search !== '' &&
  //         //         whole !== 'null' &&
  //         //         isTitleFault !== 'null' &&
  //         //         statusSearch !== 0) ||
  //         //       (Search !== '' && whole !== 'null' && statusSearch !== 0) ||
  //         //       (Search !== '' && isTitleFault !== 'null' && whole !== '') ||
  //         //       (statusSearch !== 0 &&
  //         //         isTitleFault !== 'null' &&
  //         //         whole !== 'null') ||
  //         //       (Search !== '' && isTitleFault !== 'null') ||
  //         //       (Search !== '' && whole !== 'null') ||
  //         //       (Search !== '' && statusSearch !== 0) ||
  //         //       (statusSearch !== 0 && isTitleFault !== 'null') ||
  //         //       (statusSearch !== 0 && whole !== 'null') ||
  //         //       (isTitleFault !== 'null' && whole !== 'null') ||
  //         //       Search !== '' ||
  //         //       statusSearch !== 0 ||
  //         //       isTitleFault !== 'null' ||
  //         //       whole !== 'null'
  //         //     ) {
  //         //       SearchFun();
  //         //     } else {
  //         //       fetchListRelation(page ? page : 1);
  //         //     }
  //         //     alert("اطلاعات شما با موفقیت ثبت شد ")
  //         //   }
  //         // });
  //       }
  //     }
  //     // try {
  //     //   await fetch(
  //     //     `${process.env.REACT_APP_BASE_URL}/api/Admin/EditRelation?ID=${caseData.ID}&Law_ID=${caseData.Law_ID}&Section_ID=${caseData.Section_ID}&reSection_ID=${caseData.reSection_ID}&reLaw_ID=${caseData.reLaw_ID}&status=${caseData.Status_ID}&FinalText=${caseData.FinalSectionText}&ExpireDate=${caseData.ExpireDate}&isChecked=${caseData.isChecked}&ChangeText=${caseData.ChangeText}`,
  //     //     {
  //     //       method: 'POST',

  //     //       headers: {
  //     //         Authorization: `Bearer ${tokenLogin.data?.accessToken}`,
  //     //       },
  //     //     },
  //     //   ).then((res) => {
  //     //     console.log(res);
  //     //     // setCreateModal(false);
  //     //     fetchListRelation(page ? page : 1);
  //     //   });
  //     // } catch (error) {
  //     //   console.log(error);
  //     // }
  //   } else {
  //     alert('لطفا بعد از چند دقیقه دوباره امتحان کنید. ');

  //     fetchRefreshToken();
  //   }
  //   // } else {
  //   //   window.location.assign('/');
  //   // }
  // };
  const handleClick = () => {
    setcaseData({
      ID: 0,
      reLaw_ID: 0,
      reSection_ID: 0 || null,
      Law_ID: 0,
      Section_ID: 0 || null,
      Status_ID: 0,
      isChecked: null,
      ExpireDate: null,
      FinalSectionText: '',
      ChangeText: '',
      withSub: false,
    });
    setTextOrderListSection({})
    setCreateModal(true);
    setSelectedOptionReLaw(null);
    setSelectedOptionLaw(null);
    setListReSection([]);
    setListSections([]);
    // fetchStatus();
  };
  const handleCkeckWithSub = (e) => {
    setcaseData({ ...caseData, withSub: e.target.checked });
  };
  // console.log(SearchResult);
  console.log(caseData);
  if (loading) return <h1>loading.....</h1>;
  return (
    <>
      <Breadcrumb pageName="اطلاعات تنقیحی" />
      <div className="w-full max-w-full p-10 rounded-sm border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark">
        {/* Search */}
        <div className="w-full md:grid grid-cols-9 items-center justify-between  rounded-xl mb-5 font-IranSans ">
          {/* input */}
          <div className="w-full  md:mt-0 mt-3 flex items-center">
            <input
              className="border-2 w-[90%] relative border-[#E5E1DA] outline-none p-2 rounded-lg text-[14px]"
              placeholder="جستجوی قانون"
              onChange={onchangeSearch}
              value={Search}
            />
          </div>
          {/* isTitleFault */}
          <div className="w-full flex items-center  md:mt-0 mt-3">
            <select
              defaultValue={isTitleFault}
              onChange={handleisTitleFault}
              className="border-2 w-[90%] relative border-[#E5E1DA] outline-none p-2 rounded-lg text-[14px]"
            >
              <option value="null"></option>
              {isTitleFault == 0 ? (
                <option value="0" selected>
                  خطا عنوان
                </option>
              ) : (
                <option value="0">خطا عنوان</option>
              )}
              {isTitleFault == 1 ? (
                <option value="1" selected>
                  خطا ساختار
                </option>
              ) : (
                <option value="1">خطا ساختار</option>
              )}
              {isTitleFault === 2 ? (
                <option value="2" selected>
                  فاقد خطا
                </option>
              ) : (
                <option value="2">فاقد خطا</option>
              )}
            </select>
          </div>
          {/* tanghih */}
          <div className="w-full flex items-center  md:mt-0 mt-3">
            <select
              onChange={handleChangeSearchStatus}
              defaultValue={SearchStatus}
              className="border-2 w-[90%] relative border-[#E5E1DA] outline-none p-2 rounded-lg text-[14px]"
            >
              <option value="0"></option>
              {SearchStatus.map((item) => {
                return item.ID == SearchStatus ? (
                  <option value={item.id} selected>
                    {item.title}
                  </option>
                ) : (
                  <option value={item.id}>{item.title}</option>
                );
              })}
            </select>
          </div>
          {/* state */}
          <div className="w-full  md:mt-0 mt-3 flex items-center ">
            <select
              onChange={handleWhole}
              defaultValue={whole}
              className="border-2 w-[90%] relative border-[#E5E1DA] outline-none p-2 rounded-lg text-[14px]"
            >
              <option value="null"></option>
              <option value="true">وضعیت کلی </option>
              <option value="false">وضعیت جزئی</option>
            </select>
          </div>
          {/* type */}
          <div className="w-full  md:mt-0 mt-3 ml-5 flex items-center ">
            <LawType changeTypeFun={handleType} type={Type} />
            {/* <select onChange={handleType} className="border-2 w-[90%] relative border-[#E5E1DA] outline-none p-2 rounded-lg text-[14px]">
              <option value="null">نوع</option>
              <option value="1"></option>
              <option value="2"></option>
            </select> */}
          </div>
          {/* confirm */}
          <div className="w-full  md:mt-0 mt-3 flex items-center ">
            <select
              onChange={handleConfirm}
              className="border-2 w-[90%] relative border-[#E5E1DA] outline-none p-2 rounded-lg text-[14px]"
              defaultValue={confirm}
            >
              <option value="null"></option>
              <option value="0">تایید عدم</option>
              <option value="1">اولیه تایید</option>
              <option value="2">نهایی تایید</option>
            </select>
          </div>
          <div className="w-full  md:mt-0 mt-3 flex items-center">
            <select
              onChange={isReplatedCheckedfun}
              className="border-2 w-[90%] relative border-[#E5E1DA] outline-none p-2 rounded-lg text-[14px]"
              defaultValue={isReplatedChecked}
            >
              {isReplatedChecked == null ? (
                <option value="null" selected></option>
              ) : (
                <option value="null"></option>
              )}
              {isReplatedChecked == true ? (
                <option value="true" selected>
                  نمایش همه منسوخه ها{' '}
                </option>
              ) : (
                <option value="true">نمایش همه منسوخه ها </option>
              )}
              {isReplatedChecked == false ? (
                <option value="false" selected>
                  عدم نمایش منسوخه ها{' '}
                </option>
              ) : (
                <option value="false">عدم نمایش منسوخه ها </option>
              )}
            </select>
            {/* <input
           
            onChange={isReplatedCheckedfun}
            id="default-checkbox"
            type="checkbox"
            value=""
            className="w-5 h-5 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 dark:bg-gray-700 dark:border-gray-600"
          />
            <label
            for="default-checkbox"
            className="ms-2 font-IranSans font-[16px] text-gray-900 dark:text-gray-300 ml-3"
          >
           نمایش همه منسوخه ها 
          </label> */}
          </div>
          {/* date */}
          <div className="w-full  md:mt-0 mt-3 flex items-center ">
            <div className="w-full flex items-center  ">
              <label className="ml-3 mr-3">از </label>
              <DatePicker
                className="custom-calendar"
                inputClass="custom-input"
                calendarPosition="bottom-center"
                value={fromDate}
                locale={persian_fa}
                calendar={persian}
                onChange={handleFromDate}
              />
            </div>
          </div>
          <div className="w-full  md:mt-0 mt-3 flex items-center ">
            <div className="w-full flex items-center ">
              <label className="ml-3 mr-3">تا </label>
              <DatePicker
                className="custom-calendar"
                inputClass="custom-input"
                calendarPosition="bottom-center"
                value={ToDate}
                locale={persian_fa}
                calendar={persian}
                onChange={handleToDate}
              />
            </div>
          </div>
          {/* end date */}

          {/* search btn */}
        </div>
        <div className="w-full  flex items-center">
          {/* <div className="w-[5%] md:flex md:mt-0 mt-3 items-center justify-between bg-red-500"> */}
          <div className="mr-3 w-full md:mt-0 mt-3 flex items-center">
            {/* <button className="button" onClick={SearchFun}> */}
            <button className="buttonsearch" onClick={MainSaerchFun}>
              <IoSearchSharp size={35} className=" svgIcon " />
            </button>
          </div>
          <button className=" md:mt-0 mt-3 " onClick={handleClick}>
            <span className="box font-IranSans text-[16px]">جدید</span>
          </button>
          <button className=" md:mt-0 mt-3">
            <span className="box font-IranSans text-[16px]">تنقیح هوشمند</span>
          </button>
          {/* </div> */}
        </div>
        {/* table */}
        <div className="w-full overflow-auto mt-10">
          <table className="overflow-auto w-full text-[14px]">
            <thead>
              <tr className="font-IranSans w-full bg-[#B1B2FF] text-[#030637]">
                <th className="w-10 border-b p-3 text-[14px]">ردیف</th>
                <th className="w-[100rem] border-b p-3 text-[14px]">
                  قانون اثرگذار
                </th>
                <th className="w-36 border-b p-3 text-[14px]">
                  ساختار اثرگذار
                </th>
                <th className="w-[100rem] border-b p-3 text-[14px]">
                  قانون اثرپذیر
                </th>
                <th className="w-36 border-b p-3 text-[14px]">
                  ساختار اثرپذیر{' '}
                </th>
                <th className="w-40 border-b p-3 text-[14px]">وضعیت تنقیحی</th>
                {/* <th className="w-10 border-b p-3 text-[14px]">ویرایش</th> */}
              </tr>
            </thead>
            <tbody className="font-IranSans ">
              {SearchResult.length !== 0 ? (
                <>
                  {/* {SearchResult.length == 0 ? (
                    // <>
                    //   <tr className="IranSana">موردی یافت نشد </tr>
                    // </>
                  ) : ( */}

                  {SearchResult.map((item: {}) => {
                    return (
                      <>
                        {item.isChecked == 0 && (
                          <>
                            <tr className="bg-[#FFA36C] text-black">
                              <td
                                title={item.ID}
                                className="w-10 border-b text-center font-IranSans p-3"
                              >
                                {(rowNumber = rowNumber + 1)}
                              </td>
                              <td className="w-[100rem] border-b  p-3">
                                <div className="hover:text-[#0891b2] text-justify rtl inline ">
                                  <Link
                                    target="_blank"
                                    to={`https://ilaws.net/ViewText/${item.reLaw_ID}`}
                                    className="inline w-full"
                                  >
                                    {item.reLawTitle}
                                  </Link>
                                  <Link
                                    target="_blank"
                                    to={`https://qavanin.ir/Law/TreeText/${item.reOld_ID}`}
                                    className="inline"
                                  >
                                    <span className="">
                                      {item.reApproveDate}
                                    </span>
                                  </Link>
                                </div>
                              </td>

                              <td className="w-36 border-b text-center">
                                {item.reSectionPath_New !== '' ? (
                                  item.reSectionPath_New
                                ) : (
                                  <>.......</>
                                )}
                              </td>
                              <td className="w-[100rem] border-b  p-3 ">
                                <div className="hover:text-[#06b6d4] text-justify inline">
                                  <Link
                                    target="_blank"
                                    to={`https://ilaws.net/ViewText/${item.Law_ID}`}
                                    className="inline"
                                  >
                                    {item.LawTitle}
                                  </Link>
                                  <Link
                                    target="_blank"
                                    to={`https://qavanin.ir/Law/TreeText/${item.Old_ID}`}
                                    className="w-full inline"
                                  >
                                    <p className="inline">
                                      {' '}
                                      {item.ApproveDate}
                                    </p>
                                  </Link>
                                </div>
                              </td>
                              <td className="w-36 border-b text-center">
                                {item.SectionPath_New !== '' ? (
                                  item.SectionPath_New
                                ) : (
                                  <>.......</>
                                )}
                              </td>

                              <td className="w-40 border-b text-center p-3">
                                <p
                                  onClick={() => EditListRelation(item)}
                                  className="text-[13px] bg-[#06b6d4] hover:text-[#06b6d4] hover:border hover:font-bold hover:border-[#06b6d4] cursor-pointer hover:bg-[#ffffff] text-center w-[100%] p-2 rounded-md text-[#ffffff]"
                                >
                                  {item.Status}
                                </p>
                              </td>
                            </tr>
                          </>
                        )}
                        {item.isChecked == 1 && (
                          <>
                            <tr className="bg-[#ACD793] text-black">
                              <td
                                title={item.ID}
                                className="w-10 border-b text-center font-IranSans p-3"
                              >
                                {(rowNumber = rowNumber + 1)}
                              </td>
                              <td className="w-[100rem] border-b  p-3">
                                <div className="hover:text-[#0891b2] text-justify rtl inline ">
                                  <Link
                                    target="_blank"
                                    to={`https://ilaws.net/ViewText/${item.reLaw_ID}`}
                                    className="inline w-full"
                                  >
                                    {item.reLawTitle}
                                  </Link>
                                  <Link
                                    target="_blank"
                                    to={`https://qavanin.ir/Law/TreeText/${item.reOld_ID}`}
                                    className="inline"
                                  >
                                    <span className="">
                                      {item.reApproveDate}
                                    </span>
                                  </Link>
                                </div>
                              </td>

                              <td className="w-36 border-b text-center">
                                {item.reSectionPath_New !== '' ? (
                                  item.reSectionPath_New
                                ) : (
                                  <>.......</>
                                )}
                              </td>
                              <td className="w-[100rem] border-b  p-3 ">
                                <div className="hover:text-[#06b6d4] text-justify inline">
                                  <Link
                                    target="_blank"
                                    to={`https://ilaws.net/ViewText/${item.Law_ID}`}
                                    className="inline"
                                  >
                                    {item.LawTitle}
                                  </Link>
                                  <Link
                                    target="_blank"
                                    to={`https://qavanin.ir/Law/TreeText/${item.Old_ID}`}
                                    className="w-full inline"
                                  >
                                    <p className="inline">
                                      {' '}
                                      {item.ApproveDate}
                                    </p>
                                  </Link>
                                </div>
                              </td>
                              <td className="w-36 border-b text-center">
                                {item.SectionPath_New !== '' ? (
                                  item.SectionPath_New
                                ) : (
                                  <>.......</>
                                )}
                              </td>

                              <td className="w-40 border-b text-center p-3">
                                <p
                                  onClick={() => EditListRelation(item)}
                                  className="text-[13px] bg-[#06b6d4] hover:text-[#06b6d4] hover:border hover:font-bold hover:border-[#06b6d4] cursor-pointer hover:bg-[#ffffff] text-center w-[100%] p-2 rounded-md text-[#ffffff]"
                                >
                                  {item.Status}
                                </p>
                              </td>
                            </tr>
                          </>
                        )}
                        {item.isChecked == 2 && (
                          <>
                            <tr className="bg-[#004225] text-white">
                              <td
                                title={item.ID}
                                className="w-10 border-b text-center font-IranSans p-3"
                              >
                                {(rowNumber = rowNumber + 1)}
                              </td>
                              <td className="w-[100rem] border-b p-3">
                                <div className="hover:text-[#0891b2] text-justify inline">
                                  <Link
                                    target="_blank"
                                    to={`https://ilaws.net/ViewText/${item.reLaw_ID}`}
                                    className="inline"
                                  >
                                    {item.reLawTitle}
                                  </Link>
                                  <Link
                                    target="_blank"
                                    to={`https://qavanin.ir/Law/TreeText/${item.reOld_ID}`}
                                    className="w-full inline"
                                  >
                                    <p className="inline">
                                      {' '}
                                      {item.reApproveDate}
                                    </p>
                                  </Link>
                                </div>
                              </td>
                              <td className="w-36 border-b text-center">
                                {item.reSectionPath_New !== ''
                                  ? item.reSectionPath_New
                                  : '.............'}
                              </td>
                              <td className="w-[100rem] border-b p-3 ">
                                <div className="hover:text-[#06b6d4] text-justify inline">
                                  <Link
                                    target="_blank"
                                    to={`https://ilaws.net/ViewText/${item.Law_ID}`}
                                    className="inline"
                                  >
                                    {item.LawTitle}
                                  </Link>
                                  <Link
                                    target="_blank"
                                    to={`https://qavanin.ir/Law/TreeText/${item.Old_ID}`}
                                    className="inline w-full"
                                  >
                                    <p className="inline">
                                      {' '}
                                      {item.ApproveDate}
                                    </p>
                                  </Link>
                                </div>
                              </td>
                              <td className="w-36 border-b">
                                {item.SectionPath_New !== '' ? (
                                  item.SectionPath_New
                                ) : (
                                  <>.......</>
                                )}
                              </td>
                              <td className="w-40 border-b text-center p-3">
                                <p
                                  onClick={() => EditListRelation(item)}
                                  className="text-[13px] bg-[#06b6d4] hover:text-[#06b6d4] hover:border hover:font-bold hover:border-[#06b6d4] cursor-pointer hover:bg-[#ffffff] text-center w-[100%] p-2 rounded-md text-[#ffffff]"
                                >
                                  {item.Status}
                                </p>
                              </td>
                            </tr>
                          </>
                        )}
                        {item.isChecked == null && (
                          <>
                            <tr>
                              <td
                                title={item.ID}
                                className="w-10 border-b text-center font-IranSans p-3"
                              >
                                {(rowNumber = rowNumber + 1)}
                              </td>
                              <td className="w-[100rem] border-b  p-3">
                                <div className="hover:text-[#0891b2] text-justify inline">
                                  <Link
                                    target="_blank"
                                    to={`https://ilaws.net/ViewText/${item.reLaw_ID}`}
                                    className="inline"
                                  >
                                    {item.reLawTitle}
                                  </Link>
                                  <Link
                                    target="_blank"
                                    to={`https://qavanin.ir/Law/TreeText/${item.reOld_ID}`}
                                    className="inline w-full"
                                  >
                                    {item.reApproveDate !== null && (
                                      <p className="inline">
                                        {item.reApproveDate}{' '}
                                      </p>
                                    )}
                                  </Link>
                                </div>
                              </td>
                              <td className="w-36 border-b text-center">
                                {item.reSectionPath_New !== '' ? (
                                  item.reSectionPath_New
                                ) : (
                                  <>.......</>
                                )}
                              </td>
                              <td className="w-[100rem] border-b  p-3 ">
                                <div className="hover:text-[#06b6d4] text-justify inline">
                                  <Link
                                    target="_blank"
                                    to={`https://ilaws.net/ViewText/${item.Law_ID}`}
                                    className="inline"
                                  >
                                    {item.LawTitle}
                                  </Link>
                                  <Link
                                    target="_blank"
                                    to={`https://qavanin.ir/Law/TreeText/${item.Old_ID}`}
                                  >
                                    {item.ApproveDate !== null && (
                                      <p className="inline">
                                        {' '}
                                        {item.ApproveDate}{' '}
                                      </p>
                                    )}
                                  </Link>
                                </div>
                              </td>
                              <td className="w-36 border-b">
                                {item.SectionPath_New !== '' ? (
                                  item.SectionPath_New
                                ) : (
                                  <>.......</>
                                )}
                              </td>
                              <td className="w-40 border-b text-center p-3">
                                <p
                                  onClick={() => EditListRelation(item)}
                                  className="text-[13px] bg-[#06b6d4] hover:text-[#06b6d4] hover:border hover:font-bold hover:border-[#06b6d4] cursor-pointer hover:bg-[#ffffff] text-center w-[100%] p-2 rounded-md text-[#ffffff]"
                                >
                                  {item.Status}
                                </p>
                              </td>

                              {/* <td className="w-10 border-b text-center p-3">
                                <div className="w-full flex items-center justify-center">
                                  <button
                                    // className="edit-button"
                                    className="w-10 h-10 flex items-center justify-center rounded-xl bg-[#22d3ee]
                                  hover:border-2 hover:border-[#22d3ee] hover:bg-[#ffffff]  hover:text-[#22d3ee] text-[#ffffff] shadow"
                                    onClick={() => EditListRelation(item)}
                                  >
                                    <BiSolidEditAlt
                                      size={20}
                                      // className="edit-svgIcon"
                                    />
                                  </button>
                                </div>
                              </td> */}
                            </tr>
                          </>
                        )}
                      </>
                    );
                  })}
                </>
              ) : (
                <>
                  {SearchResultCount == 0 ? (
                    <>
                      {' '}
                      <tr className="IranSana grid grid-cols-4">
                        <td className=""></td> <td className=""></td>{' '}
                        <td className=""></td>{' '}
                        <td className="w-full col-end-5 col-start-1">
                          موردی یافت نشد
                        </td>{' '}
                      </tr>
                    </>
                  ) : (
                    <>
                      {
                        // listRelation.map((item: {}) => {
                        //   return (
                        //     <>
                        //       {item.isChecked == 0 && (
                        //         <>
                        //           <tr className="bg-[#FFA36C] text-black">
                        //             <td
                        //               title={item.ID}
                        //               className="w-10 border-b text-center font-IranSans p-3"
                        //             >
                        //               {(rowNumber = rowNumber + 1)}
                        //             </td>
                        //             <td className="w-[100rem] border-b  p-3">
                        //               <div className="hover:text-[#0891b2] text-justify rtl inline ">
                        //                 <Link
                        //                   target="_blank"
                        //                   to={`https://ilaws.net/ViewText/${item.reLaw_ID}`}
                        //                   className="inline w-full"
                        //                 >
                        //                   {item.reLawTitle}
                        //                 </Link>
                        //                 <Link
                        //                   target="_blank"
                        //                   to={`https://qavanin.ir/Law/TreeText/${item.reOld_ID}`}
                        //                   className="inline"
                        //                 >
                        //                   <span className="">
                        //                     {item.reApproveDate}
                        //                   </span>
                        //                 </Link>
                        //               </div>
                        //             </td>
                        //             <td className="w-36 border-b text-center">
                        //               {item.reSectionPath_New !== '' ? (
                        //                 item.reSectionPath_New
                        //               ) : (
                        //                 <>.......</>
                        //               )}
                        //             </td>
                        //             <td className="w-[100rem] border-b  p-3 ">
                        //               <div className="hover:text-[#06b6d4] text-justify inline">
                        //                 <Link
                        //                   target="_blank"
                        //                   to={`https://ilaws.net/ViewText/${item.Law_ID}`}
                        //                   className="inline"
                        //                 >
                        //                   {item.LawTitle}
                        //                 </Link>
                        //                 <Link
                        //                   target="_blank"
                        //                   to={`https://qavanin.ir/Law/TreeText/${item.Old_ID}`}
                        //                   className="w-full inline"
                        //                 >
                        //                   <p className="inline">
                        //                     {' '}
                        //                     {item.ApproveDate}
                        //                   </p>
                        //                 </Link>
                        //               </div>
                        //             </td>
                        //             <td className="w-36 border-b text-center">
                        //               {item.SectionPath_New !== '' ? (
                        //                 item.SectionPath_New
                        //               ) : (
                        //                 <>.......</>
                        //               )}
                        //             </td>
                        //             <td className="w-40 border-b text-center p-3">
                        //               <p
                        //                 onClick={() => EditListRelation(item)}
                        //                 className="text-[13px] bg-[#06b6d4] hover:text-[#06b6d4] hover:border hover:font-bold hover:border-[#06b6d4] cursor-pointer hover:bg-[#ffffff] text-center w-[100%] p-2 rounded-md text-[#ffffff]"
                        //               >
                        //                 {item.Status}
                        //               </p>
                        //             </td>
                        //           </tr>
                        //         </>
                        //       )}
                        //       {item.isChecked == 1 && (
                        //         <>
                        //           <tr className="bg-[#ACD793] text-black">
                        //             <td
                        //               title={item.ID}
                        //               className="w-10 border-b text-center font-IranSans p-3"
                        //             >
                        //               {(rowNumber = rowNumber + 1)}
                        //             </td>
                        //             <td className="w-[100rem] border-b  p-3">
                        //               <div className="hover:text-[#0891b2] text-justify rtl inline ">
                        //                 <Link
                        //                   target="_blank"
                        //                   to={`https://ilaws.net/ViewText/${item.reLaw_ID}`}
                        //                   className="inline w-full"
                        //                 >
                        //                   {item.reLawTitle}
                        //                 </Link>
                        //                 <Link
                        //                   target="_blank"
                        //                   to={`https://qavanin.ir/Law/TreeText/${item.reOld_ID}`}
                        //                   className="inline"
                        //                 >
                        //                   <span className="">
                        //                     {item.reApproveDate}
                        //                   </span>
                        //                 </Link>
                        //               </div>
                        //             </td>
                        //             <td className="w-36 border-b text-center">
                        //               {item.reSectionPath_New !== '' ? (
                        //                 item.reSectionPath_New
                        //               ) : (
                        //                 <>.......</>
                        //               )}
                        //             </td>
                        //             <td className="w-[100rem] border-b  p-3 ">
                        //               <div className="hover:text-[#06b6d4] text-justify inline">
                        //                 <Link
                        //                   target="_blank"
                        //                   to={`https://ilaws.net/ViewText/${item.Law_ID}`}
                        //                   className="inline"
                        //                 >
                        //                   {item.LawTitle}
                        //                 </Link>
                        //                 <Link
                        //                   target="_blank"
                        //                   to={`https://qavanin.ir/Law/TreeText/${item.Old_ID}`}
                        //                   className="w-full inline"
                        //                 >
                        //                   <p className="inline">
                        //                     {' '}
                        //                     {item.ApproveDate}
                        //                   </p>
                        //                 </Link>
                        //               </div>
                        //             </td>
                        //             <td className="w-36 border-b text-center">
                        //               {item.SectionPath_New !== '' ? (
                        //                 item.SectionPath_New
                        //               ) : (
                        //                 <>.......</>
                        //               )}
                        //             </td>
                        //             <td className="w-40 border-b text-center p-3">
                        //               <p
                        //                 onClick={() => EditListRelation(item)}
                        //                 className="text-[13px] bg-[#06b6d4] hover:text-[#06b6d4] hover:border hover:font-bold hover:border-[#06b6d4] cursor-pointer hover:bg-[#ffffff] text-center w-[100%] p-2 rounded-md text-[#ffffff]"
                        //               >
                        //                 {item.Status}
                        //               </p>
                        //             </td>
                        //           </tr>
                        //         </>
                        //       )}
                        //       {item.isChecked == 2 && (
                        //         <>
                        //           <tr className="bg-[#004225] text-white">
                        //             <td
                        //               title={item.ID}
                        //               className="w-10 border-b text-center font-IranSans p-3"
                        //             >
                        //               {(rowNumber = rowNumber + 1)}
                        //             </td>
                        //             <td className="w-[100rem] border-b p-3">
                        //               <div className="hover:text-[#0891b2] text-justify inline">
                        //                 <Link
                        //                   target="_blank"
                        //                   to={`https://ilaws.net/ViewText/${item.reLaw_ID}`}
                        //                   className="inline"
                        //                 >
                        //                   {item.reLawTitle}
                        //                 </Link>
                        //                 <Link
                        //                   target="_blank"
                        //                   to={`https://qavanin.ir/Law/TreeText/${item.reOld_ID}`}
                        //                   className="w-full inline"
                        //                 >
                        //                   <p className="inline">
                        //                     {' '}
                        //                     {item.reApproveDate}
                        //                   </p>
                        //                 </Link>
                        //               </div>
                        //             </td>
                        //             <td className="w-36 border-b text-center">
                        //               {item.reSectionPath_New !== ''
                        //                 ? item.reSectionPath_New
                        //                 : '.............'}
                        //             </td>
                        //             <td className="w-[100rem] border-b p-3 ">
                        //               <div className="hover:text-[#06b6d4] text-justify inline">
                        //                 <Link
                        //                   target="_blank"
                        //                   to={`https://ilaws.net/ViewText/${item.Law_ID}`}
                        //                   className="inline"
                        //                 >
                        //                   {item.LawTitle}
                        //                 </Link>
                        //                 <Link
                        //                   target="_blank"
                        //                   to={`https://qavanin.ir/Law/TreeText/${item.Old_ID}`}
                        //                   className="inline w-full"
                        //                 >
                        //                   <p className="inline">
                        //                     {' '}
                        //                     {item.ApproveDate}
                        //                   </p>
                        //                 </Link>
                        //               </div>
                        //             </td>
                        //             <td className="w-36 border-b">
                        //               {item.SectionPath_New !== '' ? (
                        //                 item.SectionPath_New
                        //               ) : (
                        //                 <>.......</>
                        //               )}
                        //             </td>
                        //             <td className="w-40 border-b text-center p-3">
                        //               <p
                        //                 onClick={() => EditListRelation(item)}
                        //                 className="text-[13px] bg-[#06b6d4] hover:text-[#06b6d4] hover:border hover:font-bold hover:border-[#06b6d4] cursor-pointer hover:bg-[#ffffff] text-center w-[100%] p-2 rounded-md text-[#ffffff]"
                        //               >
                        //                 {item.Status}
                        //               </p>
                        //             </td>
                        //           </tr>
                        //         </>
                        //       )}
                        //       {item.isChecked == null && (
                        //         <>
                        //           <tr>
                        //             <td
                        //               title={item.ID}
                        //               className="w-10 border-b text-center font-IranSans p-3"
                        //             >
                        //               {(rowNumber = rowNumber + 1)}
                        //             </td>
                        //             <td className="w-[100rem] border-b  p-3">
                        //               <div className="hover:text-[#0891b2] text-justify inline">
                        //                 <Link
                        //                   target="_blank"
                        //                   to={`https://ilaws.net/ViewText/${item.reLaw_ID}`}
                        //                   className="inline"
                        //                 >
                        //                   {item.reLawTitle}
                        //                 </Link>
                        //                 <Link
                        //                   target="_blank"
                        //                   to={`https://qavanin.ir/Law/TreeText/${item.reOld_ID}`}
                        //                   className="inline w-full"
                        //                 >
                        //                   {item.reApproveDate !== null && (
                        //                     <p className="inline">
                        //                       {item.reApproveDate}{' '}
                        //                     </p>
                        //                   )}
                        //                 </Link>
                        //               </div>
                        //             </td>
                        //             <td className="w-36 border-b text-center">
                        //               {item.reSectionPath_New !== '' ? (
                        //                 item.reSectionPath_New
                        //               ) : (
                        //                 <>.......</>
                        //               )}
                        //             </td>
                        //             <td className="w-[100rem] border-b  p-3 ">
                        //               <div className="hover:text-[#06b6d4] text-justify inline">
                        //                 <Link
                        //                   target="_blank"
                        //                   to={`https://ilaws.net/ViewText/${item.Law_ID}`}
                        //                   className="inline"
                        //                 >
                        //                   {item.LawTitle}
                        //                 </Link>
                        //                 <Link
                        //                   target="_blank"
                        //                   to={`https://qavanin.ir/Law/TreeText/${item.Old_ID}`}
                        //                 >
                        //                   {item.ApproveDate !== null && (
                        //                     <p className="inline">
                        //                       {' '}
                        //                       {item.ApproveDate}{' '}
                        //                     </p>
                        //                   )}
                        //                 </Link>
                        //               </div>
                        //             </td>
                        //             <td className="w-36 border-b">
                        //               {item.SectionPath_New !== '' ? (
                        //                 item.SectionPath_New
                        //               ) : (
                        //                 <>.......</>
                        //               )}
                        //             </td>
                        //             <td className="w-40 border-b text-center p-3">
                        //               <p
                        //                 onClick={() => EditListRelation(item)}
                        //                 className="text-[13px] bg-[#06b6d4] hover:text-[#06b6d4] hover:border hover:font-bold hover:border-[#06b6d4] cursor-pointer hover:bg-[#ffffff] text-center w-[100%] p-2 rounded-md text-[#ffffff]"
                        //               >
                        //                 {item.Status}
                        //               </p>
                        //             </td>
                        //             {/* <td className="w-10 border-b text-center p-3">
                        //           <div className="w-full flex items-center justify-center">
                        //             <button
                        //               // className="edit-button"
                        //               className="w-10 h-10 flex items-center justify-center rounded-xl bg-[#22d3ee]
                        //             hover:border-2 hover:border-[#22d3ee] hover:bg-[#ffffff]  hover:text-[#22d3ee] text-[#ffffff] shadow"
                        //               onClick={() => EditListRelation(item)}
                        //             >
                        //               <BiSolidEditAlt
                        //                 size={20}
                        //                 // className="edit-svgIcon"
                        //               />
                        //             </button>
                        //           </div>
                        //         </td> */}
                        //           </tr>
                        //         </>
                        //       )}
                        //     </>
                        //   );
                        // })
                      }
                    </>
                  )}
                </>
              )}
            </tbody>
          </table>
          {/* Page num */}
          {SearchResult.length !== 0 ? (
            <>
              <div className="md:flex w-full md:items-center md:justify-between grid grid-cols-1 mt-3">
                <div className="rtl w-full flex flex-col">
                  <div className="flex ">
                    <label className="text-lg">تعداد نمایش در صفحه </label>
                    <select
                      className="border-b p-1 mr-3 rounded-lg border-gray-400 outline-none"
                      style={{ fontFamily: 'IranSans' }}
                      onChange={handleChangSizeSearch}
                      value={pageSize}
                    >
                      <option value="10">10</option>
                      <option value="30">30</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                      <option value="300">300</option>
                      <option value="500">500</option>
                      <option value="1000">1000</option>
                    </select>
                  </div>
                  {SearchResultCount > 10 && (
                    <label className="mt-3">
                      نمایش همه موارد
                      <input
                        type="checkbox"
                        // value={checked}

                        checked={checked}
                        onChange={handleCheck}
                        className="w-5 h-5 mr-5 "
                      />
                    </label>
                  )}
                </div>
                <div className="flex w-full items-center justify-center font-IranSans">
                  <ReactPaginate
                    breakLabel={<span className="mr-4 sm:mr-0">...</span>}
                    nextLabel={
                      <span className="w-10 h-10 sm:w-5 sm:h-5 flex items-center justify-center bg-[#D3D3D3] rounded-md mr-4 sm:mr-2 sm:p-2">
                        <BsChevronLeft />
                      </span>
                    }
                    onPageChange={onChagngePageSearchResult}
                    pageRangeDisplayed={5}
                    pageCount={Math.ceil(SearchResultCount / pageSize)}
                    previousLabel={
                      <span className="w-10 h-10 sm:w-5 sm:h-5 flex items-center justify-center bg-[#D3D3D3] rounded-md">
                        <BsChevronRight />
                      </span>
                    }
                    initialPage={savePage - 1}
                    containerClassName="flex items-center justify-center mt-4 mb-4 flex-wrap"
                    pageClassName="block border- border-solid border-[#D3D3D3] hover:bg-gray-200 w-10 h-10  flex items-center justify-center rounded-md mr-4"
                    activeClassName={
                      savePage ? 'bg-[#06b6d4] text-white hover:text-black' : ''
                    }
                    // current
                  />
                  {/* <ReactPaginate
                    className="PaginateBody"
                    previousLabel={<GrFormNext size={25} />}
                    nextLabel={<GrFormPrevious size={25} />}
                    breakLabel={'...'}
                    pageCount={SearchResultCount / pageSize}
                    marginPagesDisplayed={4}
                    onPageChange={onChagngePageSearchResult}
                    pageClassName={'reactPaginate'}
                    previousClassName={'previous'}
                    nextClassName={'Next'}
                    breakClassName={'break'}
                  /> */}
                </div>
              </div>
            </>
          ) : (
            <>
              <div className=" flex w-full items-center justify-between">
                <div className="rtl w-full flex flex-col font-IranSans items-center ">
                  <div className="w-full flex  items-center">
                    <label className="text-[14px]">تعداد نمایش در صفحه </label>
                    <select
                      className="border p-1 mr-3 text-[14px] font-IranSans rounded-lg outline-none"
                      onChange={handleChangeSize}
                      defaultValue={pageSize}
                    >
                      <option value="10">10</option>
                      <option value="30">30</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                      <option value="300">300</option>
                      <option value="500">500</option>
                      <option value="1000">1000</option>
                    </select>
                  </div>
                </div>
                <div className="flex w-full items-center justify-center font-IranSans">
                  <ReactPaginate
                    breakLabel={<span className="mr-4 sm:mr-0">...</span>}
                    nextLabel={
                      <span className="w-10 h-10 sm:w-5 sm:h-5 flex items-center justify-center bg-[#D3D3D3] rounded-md mr-4 sm:mr-2 sm:p-2">
                        <BsChevronLeft />
                      </span>
                    }
                    onPageChange={onChagngePage}
                    pageRangeDisplayed={5}
                    pageCount={Math.ceil(pageCount / pageSize)}
                    previousLabel={
                      <span className="w-10 h-10 sm:w-5 sm:h-5 flex items-center justify-center bg-[#D3D3D3] rounded-md">
                        <BsChevronRight />
                      </span>
                    }
                    initialPage={savePage - 1}
                    containerClassName="flex items-center justify-center mt-4 mb-4 flex-wrap"
                    pageClassName="block border- border-solid border-[#D3D3D3] hover:bg-gray-200 w-10 h-10  flex items-center justify-center rounded-md mr-4"
                    activeClassName={
                      savePage ? 'bg-[#06b6d4] text-white hover:text-black' : ''
                    }
                    // current
                  />
                </div>
                {/* <div className="flex w-full">
                  <ReactPaginate
                    className="PaginateBody"
                    previousLabel={<GrFormNext size={25} />}
                    nextLabel={<GrFormPrevious size={25} />}
                    breakLabel={'...'}
                    pageCount={Math.ceil(pageCount / pageSize)}
                    marginPagesDisplayed={4}
                    onPageChange={onChagngePage}
                    pageClassName={'reactPaginate'}
                    previousClassName={'previous'}
                    nextClassName={'Next'}
                    breakClassName={'break'}
                  />
                </div> */}
              </div>
            </>
          )}
        </div>
        {/* modals */}
        {open && (
          <div className="ModalBackground">
            <div className="Modal-innerInfo">
              <FaRegWindowClose
                onClick={() => setOpen(false)}
                className="mb-2"
                size={25}
              />
              {/* copy */}
              {/* <div className="w-full border-2 border-[#E5E1DA] rounded-lg p-3">
                  <section
                      className="w-full text-center mt-10 text-xl font-bold"
                     
                    >
                      {objectEdit.LawTitle}
                    </section>
                </div> */}

              {/* main */}

              <div className="w-full h-full  rounded-lg px-3 font-IranSans">
                <section className="w-full text-center mt-2 text-[14px] font-bold">
                  {objectEdit.LawTitleText !== null &&
                    objectEdit.LawTitleText + ' '}
                  {objectEdit.ApproveDate !== null ? (
                    <>مصوب :{objectEdit.ApproveDate}</>
                  ) : (
                    ''
                  )}
                </section>
                {/* Law_ID and section_ID */}

                <div className="w-full flex flex-col  py-2">
                  <div className="w-full flex items-center justify-between">
                    <div className="w-full h-full flex items-center justify-between flex-col">
                      <div className="w-full items-center justify-center flex">
                        <div className="w-[30%] flex flex-col text-[14px]">
                          <p className=" font-bold">قانون اثر گذار :</p>
                          <Link
                            target="_blank"
                            to={`https://ilaws.net/ViewText/${caseData.reLaw_ID}`}
                          >
                            <label className="text-[#40A2D8] text-underline font-bold cursor-pointer">
                              {Number.isNaN(caseData.reLaw_ID)
                                ? ''
                                : caseData.reLaw_ID}
                            </label>
                          </Link>
                        </div>
                        <div className="w-[100%] flex flex-col text-[14px]">
                          <SearchableDropDownReLaw
                            LawTitle={objectEdit.reLawTitle}
                            // ListReSection={fetchListReSection}
                          />
                        </div>
                      </div>
                      <div className="mt-3"></div>
                    </div>
                  </div>
                  <div className="w-[100%]  flex items-center justify-between gap-2 ">
                    <div className="w-[50%]  flex items-center ">
                      <p className="w-[25%]  font-bold   text-[14px]">
                        ساختار اثر گذار:
                      </p>
                      <select
                        onChange={handlerChangereSection}
                        className="w-[75%] border   outline-none border-body p-1 rounded-md"

                        // defaultValue={objectEdit.reSection_ID}
                      >
                        <option
                          className="text-[14px]"
                          defaultValue={objectEdit.reSection_ID}
                        >
                          {objectEdit.reSectionPath_New}
                        </option>
                        <option value="0">خطا ساختار</option>
                        {/* <option value={objectEdit.reSection_ID} selected>
                              {objectEdit.reSectionPath_New}
                            </option> */}
                        {listReSection.length !== 0 &&
                          listReSection.map((item, index) => {
                            return (
                              <>
                                <option key={index} value={item.ID}>
                                  {item.SectionPath}
                                </option>
                              </>
                            );
                          })}
                      </select>
                    </div>
                    <div
                      className=" py-1 w-[50%] text-[14px]"
                      // className="font-bold text-center w-[50%] flex items-center justify-center"
                    >
                      {' '}
                      ساختار اثرگذار قبلی : {objectEdit.reSectionPath}
                    </div>
                  </div>
                </div>

                <div className="w-full flex flex-col mt-3 py-2">
                  <div className="w-full h-full flex items-center justify-between ">
                    <div className="w-full flex items-center justify-between">
                      <div className="w-[30%] flex flex-col">
                        <p className=" font-bold text-[14px]">
                          قانون اثر پذیر :
                        </p>
                        <Link
                          target="_blank"
                          to={`https://ilaws.net/ViewText/${caseData.Law_ID}`}
                        >
                          <label className="text-[#40A2D8] font-bold cursor-pointer">
                            {Number.isNaN(caseData.Law_ID)
                              ? ''
                              : caseData.Law_ID}
                          </label>
                        </Link>
                      </div>
                      <div className="w-[70%] flex flex-col ">
                        <SearchableDropDownLaw LawTitle={objectEdit.LawTitle} />
                      </div>
                    </div>
                  </div>
                  <div className="w-[100%] mt-5 flex items-center justify-between gap-2 ">
                    <div className="w-[100%] flex items-center">
                      <p className="w-[30%] text-[14px] font-bold">
                        ساختار اثر پذیر:
                      </p>
                      <select
                        id="LawSelect"
                        onChange={handlerChangeSection}
                        className="w-[70%] border  outline-none border-body p-1 rounded-md"

                        // defaultValue={objectEdit.Section_ID}
                      >
                        {/* <option value={objectEdit.Section_ID}>
                          {objectEdit.SectionPath_New}
                        </option> */}
                        {objectEdit.Section_ID == null ? (
                          <option selected value="null">
                            کلی
                          </option>
                        ) : (
                          <option value="null">کلی</option>
                        )}
                        {objectEdit.Section_ID == 0 ? (
                          <option selected value="0">
                            خطا ساختار
                          </option>
                        ) : (
                          <option value="0">خطا ساختار</option>
                        )}
                        {/* <option value={objectEdit.Section_ID} selected>
                              {objectEdit.SectionPath_New}
                            </option> */}
                        {listSections.length !== 0 &&
                          listSections.map((item, index) => {
                            return (
                              <>
                                {item.ID === objectEdit.Section_ID ? (
                                  <option className='text-wrap' selected key={index} value={item.ID}>
                                    {item.Status_ID === 3 ? (
                                      <>{item.SectionPath + '--' + 'اصلاحی'}</>
                                    ) : item.Status_ID === 4 ? (
                                      <>{item.SectionPath + '--' + 'الحاقی'}</>
                                    ) : (
                                      <>{item.SectionPath}</>
                                    )}
                                  </option>
                                ) : (
                                  <option key={index} value={item.ID}>
                                    {item.Status_ID === 3 ? (
                                      <>{item.SectionPath + '--' + 'اصلاحی'}</>
                                    ) : item.Status_ID === 4 ? (
                                      <>{item.SectionPath + '--' + 'الحاقی'}</>
                                    ) : (
                                      <>{item.SectionPath}</>
                                    )}
                                  </option>
                                )}
                              </>
                            );
                          })}
                      </select>
                    </div>
                    <div className="flex items-center justify-between w-[100%]">
                      <div className="text-[15px] text-right w-full ">
                        {' '}
                        ساختار اثر پذیر قبلی: {objectEdit.SectionPath}
                      </div>
                      <div className="w-full flex items-center ">
                        <input
                          type="checkbox"
                          className="w-4 h-4 flex items-center justify-center"
                          onChange={handleCkeckWithSub}
                          defaultChecked={caseData.withSub}
                        />
                        <label className="flex mr-3 items-center">
                          با زیر مجموعه ها
                        </label>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="w-full grid grid-cols-2 items-center justify-between mt-3 gap-3">
                  <div className="w-full  flex items-center justify-between">
                    <label
                      className="  text-[14px] font-bold w-[30%] "
                      // style={{ fontFamily: 'Btitr' }}
                    >
                      تاریخ اعتبار :
                    </label>
                    <div className="w-[70%] flex  items-center ">
                      <DatePicker
                        className="custom-calendar"
                        inputClass="custom-input"
                        calendarPosition="bottom-center"
                        value={objectEdit.ExpireDate}
                        locale={persian_fa}
                        calendar={persian}
                        onChange={handleDate}
                      />
                    </div>
                  </div>

                  <div className="w-full flex items-center justify-between">
                    <label className="font-bold w-[30%] text-[14px]">
                      وضعیت تنقیحی :
                    </label>
                    <select
                      onChange={handleChangeStatus}
                      className="w-[70%] text-[14px] border outline-none border-body p-1 rounded-md"
                      defaultValue={objectEdit.EffectType_ID}
                    >
                      {/* <option>{objectEdit.Status}</option> */}
                      {AllStatus.map((item) => {
                        return (
                          <option key={item.id} value={item.id} className="">
                            {item.title}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                </div>
                {objectEdit.EffectType_ID === 4 || objectEdit.EffectType_ID === 3 ? (
                  <>
                    <div className="w-full grid grid-cols-3 mt-7 gap-5 ">
                      <div className="w-full flex items-center justify-between">
                        <label className="font-bold text-[14px] w-[50%] p-2 ">
                          ترتیب ساختار اثرپذیر :
                        </label>
                       {TextOrderListSection !== null &&
                          TextOrderListSection !== undefined
                            ? <label className="w-[50%]   border  outline-none border-body p-2 rounded-md">
{TextOrderListSection.TextOrder}
                        </label>:""}
                      </div>
                      <div className="w-full flex items-center">
                        <label className="font-bold text-[14px]  w-[20%] ">
                          ترتیب:
                        </label>
                        <input
                          onChange={(e) =>
                            setcaseData((prev) => ({
                              ...prev,
                              TextOrder: e.target.value,
                            }))
                          }
                          defaultValue={objectEdit.TextOrder}
                          className="   border w-[80%] outline-none border-body p-2 rounded-md"
                        />
                      </div>
                      <div className="w-full flex items-center">
                        <label className="font-bold text-[14px] w-[30%] ">
                          ترتیب ثانویه:
                        </label>
                        <input
                          onChange={(e) =>
                            setcaseData((prev) => ({
                              ...prev,
                              TextOrder2: e.target.value,
                            }))
                          }
                          defaultValue={objectEdit.TextOrder2}
                          className="  border w-[70%] outline-none border-body p-2 rounded-md"
                        />
                      </div>
                    </div>
                  </>
                ):<></>}
                <div className="w-full mt-3 items-center justify-center  flex ">
                  <label
                    className="  font-bold w-[14%] text-[14px]"
                    // style={{ fontFamily: 'Btitr' }}
                  >
                    تغییرات متن:
                  </label>
                  <input
                    type="text"
                    className="w-[100%]   border mt-3 outline-none border-body p-2 rounded-md"
                    defaultValue={objectEdit.ChangeText}
                    onChange={(e) =>
                      setcaseData({
                        ...caseData,
                        ChangeText: e.target.value,
                      })
                    }
                  />
                </div>
                <div className="w-full mt-3 items-center justify-center  flex ">
                  <label
                    className="font-bold w-[14%] text-[14px]"
                    // style={{ fontFamily: 'Btitr' }}
                  >
                    متن نهایی :
                  </label>
                  <textarea
                    rows="5"
                    cols="50"
                    className="w-full text-justify border mt-5 outline-none border-body p-5 rounded-md"
                    defaultValue={
                      objectEdit.FinalSectionText !== null
                        ? objectEdit.FinalSectionText
                        : ''
                    }
                    onChange={(e) =>
                      setcaseData({
                        ...caseData,
                        FinalSectionText: e.target.value,
                      })
                    }
                  />
                </div>
                <div className="w-full mt-3 flex items-center justify-between">
                  <label
                    className="font-bold flex  text-[14px] w-[14%] items-center  "
                    // style={{ fontFamily: 'Btitr' }}
                  >
                    وضعیت تایید:
                  </label>
                  <select
                    defaultValue="0"
                    onChange={onChangeIsChecked}
                    className="w-[100%] border  mt-3 outline-none p-1 rounded-md"
                    defaultValue={
                      objectEdit.isChecked !== null &&
                      objectEdit.isChecked === 0
                        ? '0'
                        : objectEdit.isChecked !== null &&
                          objectEdit.isChecked === 1
                        ? '1'
                        : objectEdit.isChecked !== null &&
                          objectEdit.isChecked === 2
                        ? '2'
                        : 'null'
                    }
                  >
                    <option
                      value="null"
                      className="font-bold text-[14px]"
                    ></option>
                    <option value="0" className=" text-[14px]">
                      عدم تایید
                    </option>
                    <option value="1" className=" text-[14px]">
                      تایید اولیه
                    </option>
                    <option value="2" className=" text-[14px]">
                      تایید نهایی
                    </option>
                  </select>
                </div>
                <div className="w-full mt-5">
                  <label className="font-bold text-[14px]">متن اثرگذار :</label>
                  <label className="text-justify">
                    {objectEdit.reSectionText}
                  </label>
                </div>
                <div className="w-full mt-5 flex items-center">
                  <label className="font-bold text-[14px]  w-[14%]">
                    توضیحات:
                  </label>
                  <textarea
                    rows="5"
                    cols="50"
                    className="w-full  border mt-5 outline-none border-body p-5 rounded-md"
                    defaultValue={
                      objectEdit.Comment !== 'null' &&
                      objectEdit.Comment !== 'undefined'
                        ? objectEdit.Comment
                        : ''
                    }
                    onChange={(e) =>
                      setcaseData({
                        ...caseData,
                        description: e.target.value,
                      })
                    }
                  />
                </div>

                <div className=" flex w-full gap-3 items-center ltr p-3">
                  {/* <div className='w-full flex items-center'> */}
                  <button
                    className="w-32 p-2 mb-3 rounded-full font-IranSans flex items-center justify-center text-[14px] hover:border-2 
                    text-white bg-[#65B741] font-bold 
                hover:shadow-2xl hover:shadow-black "
                    onClick={fetchEdit}
                  >
                    ثبت
                    <CiEdit size={20} className="ml-2" />
                  </button>
                  {objectEdit.SectionChange_ID !== null && (
                    <>
                      <button
                        className=" p-2 mb-3 rounded-full font-IranSans flex items-center
                     justify-center text-[14px] hover:border-2 text-white bg-[#2973B2] font-normal 
                hover:shadow-2xl hover:shadow-black "
                        onClick={() =>
                          ClickAndOpenReform(objectEdit.SectionChange_ID)
                        }
                      >
                        ویرایش بخش اصلاحی / الحاقی
                      </button>
                    </>
                  )}
                  {/* </div> */}

                  {/* <button
                className="w-40 p-2 rounded-full text-2xl text-white flex items-center justify-center
               bg-[#867AE9] font-bold hover:border-2 hover:shadow-2xl hover:shadow-black"
               
              >
                جدید{' '}
                <IoNewspaperOutline className="ml-3"/>
              </button> */}
                </div>
              </div>
            </div>
          </div>
        )}
        {openDeleteModal && (
          <>
            <div className="ModalBackground">
              <div className="Modal-innerDelete">
                <FaRegWindowClose
                  onClick={() => setOpenDeleteModal(false)}
                  className="top-1"
                />
                <p
                  className="w-full mt-3 text-xl text-center"
                  style={{ fontFamily: 'Btitr' }}
                >
                  آیا از حذف اطلاعات مطمئن هستنید ؟
                </p>
                <div
                  className="flex items-center justify-center w-full mt-2 "
                  style={{ fontFamily: 'Btitr' }}
                >
                  <button
                    className="w-full border-2 m-2 p-2 rounded-xl"
                    onClick={fetchDelete}
                  >
                    بله
                  </button>
                  <button
                    className="w-full border-2 m-2 p-2 rounded-xl"
                    onClick={() => setOpenDeleteModal(false)}
                  >
                    خیر
                  </button>
                </div>
              </div>
            </div>
          </>
        )}

        {createModal && (
          <div className="ModalBackground">
            <div className="Modal-innerCreate">
              <FaRegWindowClose
                onClick={() => setCreateModal(false)}
                className="top-1"
              />
              <div className="w-full h-full text-[14px]  font-IranSans rounded-lg p-3">
                <section className="w-full text-center  text-xl font-bold mb-3">
                  اطلاعات تنقیحی
                </section>

                <div className="w-full  mb-2 gap-3 flex flex-col ">
                  <div className="w-full flex items-center justify-between ">
                    <div className="w-[30%] flex flex-col">
                      <p className=" font-bold">قانون اثر گذار :</p>
                      <Link
                        target="_blank"
                        to={`https://ilaws.net/ViewText/${caseData.reLaw_ID}`}
                      >
                        <label className="text-[#40A2D8] text-underline font-bold cursor-pointer">
                          {Number.isNaN(caseData.reLaw_ID)
                            ? ''
                            : caseData.reLaw_ID}
                        </label>
                      </Link>
                    </div>
                    <div className="w-[70%] flex flex-col ">
                      {/* <Select
                            className="w-[100%] text-[16px] text-black"
                            placeholder="جستجوی قانون ...."
                            isClearable
                            isSearchable
                            value={selectedOptionReLaw}
                            onChange={(option) => handleChangeReLaw(option)}
                            loadOptions={loadOptionsLawList}
                          /> */}
                      <SearchableDropDownReLaw
                        LawTitle={caseData.reLawTitle}
                        // ListReSection={fetchListReSection}
                      />
                    </div>
                  </div>

                  <div className="w-[50%] flex items-center justify-between flex-col ">
                    <div className="w-[100%] flex items-center  ">
                      <p className="w-[25%]  font-bold ">ساختار اثر گذار:</p>
                      <select
                        onChange={handlerChangereSection}
                        className="w-[70%] border font-bold  outline-none border-body p-2 rounded-md"

                        // defaultValue= {objectEdit.reSectionPath_New}
                      >
                        <option></option>
                        <option value="0">خطا ساختار</option>

                        {listReSection.length !== 0 &&
                          listReSection.map((item, index) => {
                            return (
                              <>
                                <option key={index} value={item.ID}>
                                  {item.SectionPath}
                                </option>
                              </>
                            );
                          })}
                      </select>
                    </div>
                  </div>
                </div>

                <div className="w-full mt-3 flex flex-col">
                  <div className="w-full h-full flex items-center justify-between ">
                    <div className="w-[30%] flex flex-col">
                      <p className=" font-bold">قانون اثر پذیر :</p>
                      <Link
                        target="_blank"
                        to={`https://ilaws.net/ViewText/${caseData.Law_ID}`}
                      >
                        <label className="text-[#40A2D8] font-bold cursor-pointer">
                          {Number.isNaN(caseData.Law_ID) ? '' : caseData.Law_ID}
                        </label>
                      </Link>
                    </div>
                    <div className="w-[70%] flex flex-col ">
                      {/* <Select
                            className="w-[100%] text-[18px] text-black"
                            placeholder="جستجوی قانون ...."
                            isClearable
                            isSearchable
                            value={selectedOptionLaw}
                            onChange={(option) => handleChangeLaw(option)}
                            loadOptions={loadOptionsLawList}
                          /> */}
                      <SearchableDropDownLaw LawTitle={caseData.LawTitle} />
                    </div>
                  </div>
                  <div className="w-[100%] h-full flex items-center justify-between mt-5 gap-2 ">
                    <div className="w-[100%] items-center flex ">
                      <p className="w-[25%]  font-bold">ساختار اثر پذیر:</p>
                      <select
                        id="LawSelect"
                        onChange={handlerChangeSection}
                        className="w-[70%] border   outline-none border-body p-2 rounded-md"
                        defaultValue={caseData.Section_ID}

                        // defaultValue={objectEdit.SectionPath}
                      >
                        <option value="null">کلی</option>
                        <option value="0">خطا ساختار</option>
                        {/* <option value={objectEdit.Section_ID} selected> */}
                        {/* {objectEdit.SectionPath_New} */}
                        {/* </option> */}
                        {listSections.length !== 0 &&
                          listSections.map((item, index) => {
                            return (
                              <>
                                <option key={index} value={item.ID}>
                                  {item.Status_ID === 3 ? (
                                    <>{item.SectionPath + '--' + 'اصلاحی'}</>
                                  ) : item.Status_ID === 4 ? (
                                    <>{item.SectionPath + '--' + 'الحاقی'}</>
                                  ) : (
                                    <>{item.SectionPath}</>
                                  )}
                                </option>
                              </>
                            );
                          })}
                      </select>
                    </div>
                    <div className="flex items-center justify-between  w-full">
                      <div className="flex items-center ">
                        <input
                          type="checkbox"
                          className="w-5 h-5  ml-3 flex items-center justify-center"
                          onChange={handleCkeckWithSub}
                          checked={caseData.withSub}
                        />
                        <label className="flex  items-center justify-center">
                          با زیر مجموعه ها
                        </label>
                      </div>
                    </div>
                    {/* <label
                     
                      className="font-bold text-right "
                    >
                      {' '}
                      ساختار اثر پذیر قبلی: {objectEdit.SectionPath}
                    </label> */}
                  </div>
                </div>

                <div className="w-full grid grid-cols-2 items-center justify-between mt-5 gap-3">
                  {/* <div className="w-full  flex items-center justify-between  ">
                        <label
                         
                          className="w-[30%] flex  font-bold "
                          // style={{ fontFamily: 'Btitr' }}
                        >
                          تاریخ اعتبار :
                          <div className='w-[70%] flex '>
                          <DatePicker
                            className="custom-calendar"
                            inputClass="custom-input"
                            calendarPosition="bottom-center"
                            value={caseData.ExpireDate}
                            locale={persian_fa}
                            calendar={persian}
                            onChange={handleDate}
                          />
                          </div>
                        </label>
                      </div> */}
                  <div className="w-full  flex items-center justify-between">
                    <label
                      className="  text-[14px] font-bold w-[30%] "
                      // style={{ fontFamily: 'Btitr' }}
                    >
                      تاریخ اعتبار :
                    </label>
                    <div className="w-[70%] flex ">
                      <DatePicker
                        className="custom-calendar"
                        inputClass="custom-input"
                        calendarPosition="bottom-center"
                        value={caseData.ExpireDate}
                        locale={persian_fa}
                        calendar={persian}
                        onChange={handleDate}
                      />
                    </div>
                  </div>

                  <div className="w-full flex items-center justify-between">
                    <label className="font-bold w-[30%]">وضعیت تنقیحی :</label>
                    <select
                      defaultValue={caseData.Status_ID}
                      onChange={handleChangeStatus}
                      className="w-[70%] border outline-none border-body p-2 rounded-md"
                    >
                      <option></option>
                      {AllStatus.map((item) => {
                        return (
                          <option key={item.id} value={item.id} className="">
                            {item.title}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                </div>
                {caseData.Status_ID === 4 || caseData.Status_ID ===3 ?(
                  <>
                    <div className="w-full grid grid-cols-3 mt-7 gap-5 ">
                      <div className="w-full flex items-center justify-between">
                        <label className="font-bold text-[14px] w-[50%] p-2 ">
                          ترتیب ساختار اثرپذیر :
                        </label>
                        {TextOrderListSection !== null &&
                          TextOrderListSection !== undefined
                            ? <label className="w-[50%]   border  outline-none border-body p-2 rounded-md">
{TextOrderListSection.TextOrder}
                        </label>:""}
                      </div>
                      <div className="w-full flex items-center">
                        <label className="font-bold text-[14px]  w-[20%] ">
                          ترتیب:
                        </label>
                        <input
                          onChange={(e) =>
                            setcaseData((prev) => ({
                              ...prev,
                              TextOrder: e.target.value,
                            }))
                          }
                          // defaultValue={objectEdit.TextOrder}
                          className="   border w-[80%] outline-none border-body p-2 rounded-md"
                        />
                      </div>
                      <div className="w-full flex items-center">
                        <label className="font-bold text-[14px] w-[30%] ">
                          ترتیب ثانویه:
                        </label>
                        <input
                          onChange={(e) =>
                            setcaseData((prev) => ({
                              ...prev,
                              TextOrder2: e.target.value,
                            }))
                          }
                          // defaultValue={objectEdit.TextOrder2}
                          className="  border w-[70%] outline-none border-body p-2 rounded-md"
                        />
                      </div>
                    </div>
                  </>
                ):<></>}
                <div className="w-full mt-5 items-center justify-center  flex ">
                  <label
                    className="w-[14%] font-bold"
                    // style={{ fontFamily: 'Btitr' }}
                  >
                    تغییرات متن
                  </label>
                  <input
                    type="text"
                    className="w-[100%]   border mt-5 outline-none border-body p-1 rounded-md"
                    // defaultValue={objectEdit.ChangeText}
                    onChange={(e) =>
                      setcaseData({
                        ...caseData,
                        ChangeText: e.target.value,
                      })
                    }
                  />
                </div>
                <div className="w-full mt-5 items-center justify-center  flex ">
                  <label
                    className="font-bold w-[14%]"
                    // style={{ fontFamily: 'Btitr' }}
                  >
                    متن نهایی
                  </label>
                  <textarea
                    rows="5"
                    cols="50"
                    className="w-full  border mt-5 outline-none border-body p-5 rounded-md"
                    // defaultValue={
                    //   objectEdit.FinalSectionText !== null
                    //     ? objectEdit.FinalSectionText
                    //     : ''
                    // }
                    onChange={(e) =>
                      setcaseData({
                        ...caseData,
                        FinalSectionText: e.target.value,
                      })
                    }
                  />
                </div>
                <div className="w-full flex items-center justify-between">
                  <label
                    className="font-bold w-[14%] flex items-center justify-center "
                    // style={{ fontFamily: 'Btitr' }}
                  >
                    وضعیت تایید
                  </label>
                  <select
                    onChange={onChangeIsChecked}
                    className="w-[100%] border mt-5 outline-none p-2 rounded-md"
                  >
                    <option value="null" className=""></option>
                    <option value="0" className=" text-[14px]">
                      عدم تایید
                    </option>
                    <option value="1" className=" text-[14px]">
                      تایید اولیه
                    </option>
                    <option value="2" className=" text-[14px]">
                      تایید نهایی
                    </option>
                  </select>
                </div>

                {/* <div className="w-full mt-5">
                  <label className="font-bold">
                    متن اثرگذار :
                  </label>
                  <label>{objectEdit.reSectionText}</label>
                </div> */}
                <div className="w-full mt-5 flex items-center">
                  <label className="font-bold text-[14px]  w-[14%]">
                    توضیحات:
                  </label>
                  <textarea
                    rows="5"
                    cols="50"
                    className="w-full  border mt-5 outline-none border-body p-5 rounded-md"
                    // defaultValue={
                    //   objectEdit.Comment !== null ? objectEdit.Comment : ''
                    // }
                    onChange={(e) =>
                      setcaseData({
                        ...caseData,
                        description: e.target.value,
                      })
                    }
                  />
                </div>
                <div className=" flex gap-5 w-full mt-10 ltr p-5 ">
                  <button
                    className="w-40 p-2 rounded-full text-2xl text-white flex items-center justify-center
               bg-[#867AE9] font-bold hover:border-2 hover:shadow-2xl hover:shadow-black font-IranSans  text-[16px]"
                    onClick={handleClick}
                  >
                    جدید <IoNewspaperOutline className="ml-3" />
                  </button>
                  <button
                    className="w-40 p-2 rounded-full flex items-center justify-center text-2xl hover:border-2 text-white bg-[#65B741] font-bold 
                hover:shadow-2xl hover:shadow-black font-IranSans text-[16px]"
                    onClick={fetchEdit}
                  >
                    ثبت
                    <CiEdit size={30} className="ml-2" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {openEdiModal && <EditReform EditFun={ReFormEditFun} Lops={Lops} />}
      </div>
    </>
  );
};

export default NewInfo;
